export default {
  type: "Feature",
  properties: {
    name: "Өлзийт",
    location: [47.39641, 106.1031],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [106.929199637453, 48.0097623588458],
        [106.929373532163, 48.0096883140645],
        [106.929466739698, 48.0096195842764],
        [106.92950551127, 48.0095062849871],
        [106.929496643955, 48.0093874494713],
        [106.929490427841, 48.0093111662774],
        [106.929466036429, 48.0092310564681],
        [106.929426757639, 48.0091413634832],
        [106.929405712604, 48.0090933082097],
        [106.929178647277, 48.0088274695121],
        [106.929016220722, 48.0086373069662],
        [106.928882683089, 48.0085069493363],
        [106.928739520912, 48.008322759188],
        [106.928759670223, 48.0082538756159],
        [106.928921978067, 48.0081902207022],
        [106.929145721298, 48.008098876562],
        [106.929314979103, 48.0080693778995],
        [106.929477718622, 48.0080932998659],
        [106.929687844319, 48.0081697377432],
        [106.929851048787, 48.0082533971766],
        [106.929978093314, 48.0083035838434],
        [106.930150564397, 48.0083500239345],
        [106.930160918292, 48.0083534134793],
        [106.93018522247, 48.0083577652987],
        [106.930219066657, 48.0083609677845],
        [106.930262179256, 48.0083615010824],
        [106.930314467639, 48.0083568497889],
        [106.930364647111, 48.008345948207],
        [106.930407198533, 48.0083314034716],
        [106.930438842079, 48.008325842064],
        [106.930468707665, 48.0083228248386],
        [106.930528624996, 48.0083218184972],
        [106.930571504671, 48.008316068232],
        [106.930614242253, 48.0083065480088],
        [106.930634891587, 48.0082988633019],
        [106.930665873232, 48.0082843068753],
        [106.930713665004, 48.0082596150892],
        [106.930733145219, 48.0082459471928],
        [106.930746430903, 48.0082339187604],
        [106.93075525685, 48.0082224434111],
        [106.930765902125, 48.0082034173539],
        [106.930778069952, 48.0081780663647],
        [106.930782796789, 48.0081540994322],
        [106.930792905169, 48.0081237545077],
        [106.930808912202, 48.0081008541711],
        [106.9308321282, 48.0080702889127],
        [106.930847654995, 48.0080559267397],
        [106.93087392689, 48.0080356398329],
        [106.93091226319, 48.0080085927224],
        [106.930980135025, 48.0079697330168],
        [106.931101135209, 48.0078985480796],
        [106.931211089021, 48.0078325783109],
        [106.93125307387, 48.0078029546427],
        [106.931291176347, 48.0077696248683],
        [106.931319867418, 48.0077351961224],
        [106.931338032824, 48.0077105331147],
        [106.931348513523, 48.0076995101243],
        [106.931381417918, 48.0076775828542],
        [106.9314161965, 48.0076556241078],
        [106.931460242596, 48.0076309952743],
        [106.931500591579, 48.0076076848468],
        [106.931514392575, 48.0075954531677],
        [106.931525866126, 48.0075821153224],
        [106.931535037412, 48.0075662710666],
        [106.931543182572, 48.0075441063755],
        [106.931547408486, 48.0075254022756],
        [106.931550714394, 48.0074949449358],
        [106.931553562547, 48.0074207184914],
        [106.931551216216, 48.0073578927526],
        [106.931542036836, 48.0073127863561],
        [106.931527569442, 48.0072765688586],
        [106.931513429401, 48.0072491467308],
        [106.931491707177, 48.0072193369029],
        [106.93145832704, 48.0071784087566],
        [106.931424995467, 48.0071387360639],
        [106.931395218015, 48.007093975007],
        [106.931341755118, 48.0070169228927],
        [106.931293955252, 48.0069410327026],
        [106.931257905028, 48.0068787762346],
        [106.931227567298, 48.0068189371443],
        [106.931211274281, 48.006784007476],
        [106.93120270554, 48.0067552327678],
        [106.93119582213, 48.0067214020711],
        [106.931195195302, 48.006699335406],
        [106.931197689122, 48.006671080506],
        [106.931203245134, 48.0066425917822],
        [106.931217296141, 48.00659405717],
        [106.931239009373, 48.0065232841223],
        [106.931257061464, 48.0064828658916],
        [106.931282580627, 48.006435798973],
        [106.931317378994, 48.0063823468679],
        [106.931378714556, 48.006300911458],
        [106.931473585837, 48.0061823889062],
        [106.931558517811, 48.0060871183259],
        [106.931635762381, 48.0060099295147],
        [106.931706485066, 48.0059471316549],
        [106.931757455942, 48.0059072988828],
        [106.931812311889, 48.0058711731162],
        [106.931867309029, 48.0058388164083],
        [106.931951981998, 48.0057984161641],
        [106.932014609886, 48.0057697017104],
        [106.932075600109, 48.0057473031956],
        [106.932153581223, 48.005728387755],
        [106.932289277228, 48.0056997020796],
        [106.932378492673, 48.0056806004794],
        [106.932456660846, 48.005666712249],
        [106.932514234544, 48.0056531702576],
        [106.932560433617, 48.0056360471659],
        [106.93260283935, 48.0056177324724],
        [106.932637615234, 48.0055957728267],
        [106.932661158586, 48.0055740029379],
        [106.932684559845, 48.0055484639905],
        [106.932705853093, 48.0055166738555],
        [106.932716100867, 48.005490098889],
        [106.932720732376, 48.0054636183514],
        [106.932733128631, 48.0053942590379],
        [106.932743189347, 48.0053626568612],
        [106.932751846221, 48.0053436523877],
        [106.932762469013, 48.0053271291437],
        [106.932778475147, 48.0053042288072],
        [106.93279448128, 48.0052813284706],
        [106.932804681391, 48.0052534971512],
        [106.932812680861, 48.0052169010392],
        [106.932822084172, 48.0051677090226],
        [106.932828023295, 48.0051261189753],
        [106.932829252668, 48.0050970726718],
        [106.93282623904, 48.0050783721692],
        [106.932818045317, 48.0050596509822],
        [106.93280049055, 48.0050410871765],
        [106.932779096578, 48.0050200745169],
        [106.932744502357, 48.0049967676868],
        [106.932719315944, 48.0049745607275],
        [106.932703540036, 48.0049534518404],
        [106.932691553872, 48.0049335381523],
        [106.932679287119, 48.0049060854475],
        [106.932662807043, 48.0048661294683],
        [106.932646999659, 48.0048357980337],
        [106.932628723637, 48.0048063533306],
        [106.93260788005, 48.0047780327801],
        [106.932579568492, 48.0047443171965],
        [106.93252109817, 48.0046836938974],
        [106.932439408252, 48.0046033457678],
        [106.932367598286, 48.0045366619374],
        [106.932327013681, 48.0045033978136],
        [106.932296211001, 48.0044812852831],
        [106.932271213446, 48.0044641037355],
        [106.932246028831, 48.0044418967761],
        [106.932222762471, 48.0044209137942],
        [106.932201041145, 48.0043911048657],
        [106.932151510983, 48.0043190170091],
        [106.9321256222, 48.0042779611591],
        [106.932092103568, 48.004233263954],
        [106.932064529455, 48.0041972667905],
        [106.932050531507, 48.0041736137214],
        [106.932038312418, 48.0041474173695],
        [106.932033581984, 48.0041210942132],
        [106.932038306123, 48.0040971263813],
        [106.932052252809, 48.0040692312101],
        [106.932082438554, 48.0040247192654],
        [106.932118147035, 48.0039775983875],
        [106.932166869605, 48.0039277453692],
        [106.932233796253, 48.0038637550083],
        [106.93228476443, 48.0038239222363],
        [106.932322815645, 48.003789336109],
        [106.932342497308, 48.0037669870568],
        [106.932363999199, 48.0037383508443],
        [106.932381736528, 48.0037116499727],
        [106.932390158679, 48.0036863619361],
        [106.932394460136, 48.0036510860289],
        [106.932404239364, 48.0036119457347],
        [106.932414391811, 48.0035828580625],
        [106.932431988845, 48.003552387233],
        [106.932453188564, 48.0035180843921],
        [106.932522591045, 48.0034201059532],
        [106.932579640438, 48.0033424521924],
        [106.932598777112, 48.003309180874],
        [106.932623396053, 48.003259993354],
        [106.932642486861, 48.0032194384264],
        [106.932652219324, 48.0031790417794],
        [106.932661903224, 48.0031373887795],
        [106.932665923194, 48.0030945738555],
        [106.932666152521, 48.0030505655312],
        [106.932661328558, 48.0030217278705],
        [106.932648921511, 48.0029905052077],
        [106.93263080197, 48.0029568642679],
        [106.932595035932, 48.0029021459173],
        [106.932560964217, 48.0028555052774],
        [106.932473827106, 48.0027463419702],
        [106.932435355907, 48.0026898393646],
        [106.932409280064, 48.002643758103],
        [106.932395094158, 48.0026150787229],
        [106.932386573082, 48.0025875630656],
        [106.93238563419, 48.0025624333097],
        [106.9323918548, 48.0025283822791],
        [106.932405377906, 48.0024891790325],
        [106.932416747135, 48.0024424682454],
        [106.932428819634, 48.0024146054498],
        [106.932444871634, 48.0023929614661],
        [106.932470143482, 48.002367390143],
        [106.932552332524, 48.0022888685365],
        [106.932587566163, 48.0022510016824],
        [106.93260904647, 48.0022242378583],
        [106.93262322698, 48.0022026262503],
        [106.932627951119, 48.0021786575191],
        [106.932630522281, 48.0021471821468],
        [106.932635240124, 48.0020729242261],
        [106.932634020644, 48.0020402554535],
        [106.932629384638, 48.002016445003],
        [106.93261716465, 48.0019902477518],
        [106.932599046009, 48.0019566059127],
        [106.932557383117, 48.0018944438735],
        [106.932539406568, 48.0018645710931],
        [106.932527046286, 48.0018346047833],
        [106.932518477546, 48.0018058309744],
        [106.932511827959, 48.0017782829415],
        [106.932501622452, 48.001755824172],
        [106.932488000421, 48.0017422228254],
        [106.932465298835, 48.0017363187761],
        [106.932428778266, 48.0017327142934],
        [106.932370136173, 48.0017322952093],
        [106.932301085327, 48.0017334571334],
        [106.932246523458, 48.0017301602188],
        [106.932191856369, 48.0017240529228],
        [106.932092880582, 48.0017088570781],
        [106.932041669587, 48.0017004169408],
        [106.932014985803, 48.0016975202244],
        [106.931962621878, 48.0016969959197],
        [106.931914652939, 48.0017020195326],
        [106.931848060839, 48.0017129759731],
        [106.931781678282, 48.0017295504784],
        [106.931705044352, 48.0017519157184],
        [106.931628461684, 48.0017756883973],
        [106.931597378416, 48.0017890136521],
        [106.931572909662, 48.0018019162255],
        [106.931538227307, 48.0018263876777],
        [106.931513957303, 48.0018492790211],
        [106.931500149113, 48.0018719949966],
        [106.931490525467, 48.0018946399258],
        [106.931483151926, 48.0019214631051],
        [106.931476040087, 48.0019553072917],
        [106.931466731205, 48.001986377969],
        [106.931450935512, 48.0020119367016],
        [106.931426560288, 48.0020320203615],
        [106.931389681788, 48.0020537183045],
        [106.931344487258, 48.0020769612828],
        [106.931282760491, 48.0021061038137],
        [106.931220772021, 48.0021282244381],
        [106.93117719717, 48.0021387932708],
        [106.931156625178, 48.0021406287871],
        [106.931127029389, 48.0021410424752],
        [106.931078796949, 48.0021390432823],
        [106.931019736672, 48.0021273889679],
        [106.930959228486, 48.0021120708155],
        [106.930857609591, 48.0020821629615],
        [106.930773490604, 48.0020582841626],
        [106.930697491596, 48.0020416458054],
        [106.930642013318, 48.0020278232255],
        [106.930607053972, 48.0020168182216],
        [106.930579825199, 48.0020025216991],
        [106.930530269856, 48.0019791150441],
        [106.930480871895, 48.0019599208138],
        [106.930402872794, 48.0019317234703],
        [106.930313848905, 48.0019026573818],
        [106.930196183407, 48.0018635332755],
        [106.930097507094, 48.001828304133],
        [106.930048031791, 48.001807005489],
        [106.930009620847, 48.0017876259982],
        [106.929975837815, 48.0017660620542],
        [106.92994652801, 48.0017380994338],
        [106.92991211815, 48.0016996830939],
        [106.929857735246, 48.0016310396408],
        [106.929801627443, 48.0015582098435],
        [106.929753640518, 48.0014926204881],
        [106.929725311874, 48.0014505600953],
        [106.929708595275, 48.0014217116427],
        [106.929693214171, 48.0013882460707],
        [106.92968093123, 48.0013536743327],
        [106.929671277907, 48.0013053564571],
        [106.929659426641, 48.0012402140647],
        [106.929654675523, 48.001197084378],
        [106.929656556905, 48.001163328325],
        [106.929661655161, 48.0011316245249],
        [106.929672992015, 48.0010987641967],
        [106.929687623985, 48.0010700632329],
        [106.929703943982, 48.0010444937085],
        [106.929726462107, 48.0010167154491],
        [106.929755258399, 48.0009888292711],
        [106.929796294463, 48.0009523069035],
        [106.929857103023, 48.0008985903977],
        [106.929948393204, 48.0008201218512],
        [106.930011046273, 48.0007737510078],
        [106.930090333202, 48.000710238187],
        [106.930165226044, 48.0006552302547],
        [106.930221876139, 48.0006163381735],
        [106.930279937269, 48.0005732057889],
        [106.930358087456, 48.0005213050143],
        [106.930444002389, 48.0004671649278],
        [106.93054106262, 48.0004170547033],
        [106.93057786018, 48.0003932496488],
        [106.930593081206, 48.0003803479747],
        [106.930601868482, 48.0003633372982],
        [106.930604300248, 48.0003443265295],
        [106.93060335596, 48.0003190483854],
        [106.930598285582, 48.0001873723494],
        [106.930590747465, 48.0001074262168],
        [106.930586547631, 48.0000790418144],
        [106.930583226435, 48.0000607424094],
        [106.930579209163, 48.000050710472],
        [106.930562807328, 48.0000320162646],
        [106.930541816252, 48.0000165605159],
        [106.930511214121, 47.9999959975173],
        [106.930464485348, 47.9999641111548],
        [106.930422192031, 47.9999386270661],
        [106.930374639478, 47.9999129271399],
        [106.93032665615, 47.9998894944047],
        [106.930272514265, 47.9998693262085],
        [106.930193145497, 47.999846420476],
        [106.930121661086, 47.9998244356492],
        [106.930063046872, 47.9998106670287],
        [106.930014005942, 47.9998009507534],
        [106.929974380014, 47.9997910788952],
        [106.929950605536, 47.9997851550609],
        [106.929933067857, 47.9997780720005],
        [106.929904309336, 47.9997648546644],
        [106.929872531792, 47.9997479716916],
        [106.929828902082, 47.9997218580774],
        [106.929729051255, 47.9996550330534],
        [106.929679589442, 47.9996252565004],
        [106.92965827461, 47.9996098502145],
        [106.929640383497, 47.999593289199],
        [106.929625671488, 47.9995777282296],
        [106.929612487426, 47.9995610871745],
        [106.929602441999, 47.9995443930594],
        [106.929595457864, 47.9995255414706],
        [106.929583568827, 47.9995014998943],
        [106.929563362859, 47.9994649541443],
        [106.929535035114, 47.9994211652546],
        [106.92949375893, 47.9993670557451],
        [106.929463861868, 47.9993232947343],
        [106.929446754964, 47.9992856428182],
        [106.929432904505, 47.9992510962611],
        [106.929419014476, 47.9992154974973],
        [106.929395551164, 47.999175842791],
        [106.929370676815, 47.9991404292874],
        [106.929345879809, 47.9991071201975],
        [106.929299858802, 47.9990520367222],
        [106.929252307148, 47.9989980333326],
        [106.929224372407, 47.998964778202],
        [106.929201302098, 47.9989356563555],
        [106.929185920994, 47.9989021898842],
        [106.929166500134, 47.9988445523343],
        [106.92915857261, 47.9988004208028],
        [106.929155590458, 47.9987625296671],
        [106.929153546299, 47.9987077618538],
        [106.929153189268, 47.9986139706583],
        [106.929162916336, 47.998537926684],
        [106.929174446544, 47.9984681761654],
        [106.929189508389, 47.998408903648],
        [106.929202218508, 47.9983707499102],
        [106.929216692197, 47.998337836522],
        [106.929239052041, 47.9983058440395],
        [106.929264511848, 47.9982727453909],
        [106.929291502301, 47.9982385666566],
        [106.929321786971, 47.9982085490853],
        [106.929355211174, 47.9981784784541],
        [106.929396441493, 47.9981472225164],
        [106.929450363044, 47.9981124160552],
        [106.929505651565, 47.9980791672198],
        [106.929568837032, 47.9980331381189],
        [106.929609740897, 47.9980071585036],
        [106.929644577036, 47.9979868994759],
        [106.929692018972, 47.9979678347478],
        [106.92973972351, 47.9979557919263],
        [106.929810549617, 47.9979461700797],
        [106.929879437686, 47.9979407975298],
        [106.929914745969, 47.9979331766748],
        [106.929943619602, 47.9979214504147],
        [106.929955523029, 47.9979134194688],
        [106.929974113814, 47.9978970500089],
        [106.929997835232, 47.9978749626595],
        [106.930050791811, 47.9978198800834],
        [106.930166228788, 47.9977153599759],
        [106.930245155989, 47.9976423683007],
        [106.930273400997, 47.9976137887454],
        [106.930284906024, 47.9975854924766],
        [106.930294003565, 47.997555742004],
        [106.930303731532, 47.9975359056576],
        [106.930321619048, 47.9975103118514],
        [106.930335427238, 47.9974875958759],
        [106.930361578624, 47.9974590531928],
        [106.93038600511, 47.9974403742739],
        [106.93041262864, 47.9974244688642],
        [106.930428790356, 47.9974087415202],
        [106.93044463821, 47.9973845857301],
        [106.930462210063, 47.9973505661757],
        [106.930493171922, 47.9972825963148],
        [106.930524703952, 47.9972028417378],
        [106.930557759433, 47.9971058597477],
        [106.930596718064, 47.9969717114753],
        [106.930622445869, 47.9968757250347],
        [106.930630653982, 47.9968151628895],
        [106.93063655893, 47.996749020451],
        [106.93065218555, 47.9965506237124],
        [106.93065442666, 47.9964423858075],
        [106.930652120799, 47.9963805951884],
        [106.930645472111, 47.9963146622919],
        [106.930635688386, 47.9962768871687],
        [106.930616834999, 47.9962128734254],
        [106.930595351095, 47.9961496924544],
        [106.930565269672, 47.9960729110361],
        [106.930549128639, 47.9960398267766],
        [106.930536079477, 47.9960200039201],
        [106.930519936646, 47.996002084029],
        [106.9305012928, 47.995985460061],
        [106.930482822524, 47.9959724144954],
        [106.930451964986, 47.9959539694002],
        [106.930385744307, 47.9959185469034],
        [106.93034735045, 47.9958995199469],
        [106.930307229895, 47.9958903567546],
        [106.930265177596, 47.9958854437583],
        [106.930219094536, 47.9958848133335],
        [106.930162707943, 47.9958885724997],
        [106.930100098041, 47.9958938389296],
        [106.930050042675, 47.9958988958174],
        [106.930000088933, 47.9959067621874],
        [106.929969073114, 47.9959171196794],
        [106.929933924011, 47.9959289520596],
        [106.929900658089, 47.9959351322006],
        [106.929833968863, 47.9959432791591],
        [106.929752475896, 47.9959474583086],
        [106.92966224062, 47.995921745792],
        [106.929525630903, 47.9959107093118],
        [106.929440417441, 47.9959083324036],
        [106.929346485052, 47.9959003877927],
        [106.929266801522, 47.9958941087262],
        [106.929192647922, 47.9958839275013],
        [106.92907574505, 47.9958687505425],
        [106.929012437274, 47.9958450552052],
        [106.92897217013, 47.9958304960806],
        [106.928940338626, 47.995813890099],
        [106.928871785105, 47.9958017096812],
        [106.928765515816, 47.9957673088143],
        [106.928645139761, 47.9957350492332],
        [106.928584668448, 47.9957113062318],
        [106.928510017523, 47.9956878006515],
        [106.928472444748, 47.9956693870326],
        [106.928426151246, 47.9956454057109],
        [106.928385670962, 47.9956251358914],
        [106.928354336783, 47.9956218524666],
        [106.928299192154, 47.9956008991622],
        [106.928291867176, 47.9955729176561],
        [106.928284439675, 47.9955421284665],
        [106.928277219918, 47.9955169564424],
        [106.928264039454, 47.9955003153873],
        [106.928248923649, 47.9954879218302],
        [106.928229725821, 47.9954784088016],
        [106.928214504796, 47.9954632057624],
        [106.928205401858, 47.9954436859774],
        [106.92820006708, 47.9954128617143],
        [106.928199386293, 47.9953946054767],
        [106.928200746068, 47.9953749103239],
        [106.928208120508, 47.9953480880439],
        [106.92822381098, 47.9953197198292],
        [106.928237574205, 47.9953039097477],
        [106.928258121915, 47.9952854187871],
        [106.92830096112, 47.9952551898751],
        [106.928352271041, 47.9952276292518],
        [106.928397358551, 47.9952015794893],
        [106.928489623597, 47.9951494421931],
        [106.928565202622, 47.9950989911256],
        [106.928664998591, 47.995024244873],
        [106.928730274083, 47.9949781806985],
        [106.928761481457, 47.9949605971539],
        [106.928810351517, 47.9949360861315],
        [106.928925630214, 47.9948835630261],
        [106.929041117554, 47.9948366561868],
        [106.929140129314, 47.9947970518425],
        [106.929195817133, 47.9947791985012],
        [106.92929751337, 47.9947508473738],
        [106.929455000848, 47.9947074496891],
        [106.929577446242, 47.9946786938667],
        [106.929687337101, 47.9946501484856],
        [106.929742661595, 47.9946320936962],
        [106.929782372059, 47.9946162323533],
        [106.92982049522, 47.9945966469178],
        [106.929866423597, 47.9945684468764],
        [106.929937764117, 47.994516661215],
        [106.930029135236, 47.9944406505157],
        [106.93009613383, 47.9943847207783],
        [106.930128298982, 47.9943490500687],
        [106.930148017517, 47.9943163992825],
        [106.930161247444, 47.9942782356521],
        [106.930170189403, 47.9942373353847],
        [106.930175155459, 47.9942021224301],
        [106.930176353356, 47.9941535221674],
        [106.930170964618, 47.9940897764221],
        [106.930165260219, 47.9940491207703],
        [106.93015322729, 47.9940071682962],
        [106.93013293049, 47.9939681620011],
        [106.930106619925, 47.9939362864305],
        [106.93008041368, 47.9939072158454],
        [106.930064930053, 47.993884994497],
        [106.930053475388, 47.9938584869797],
        [106.930044006426, 47.9938291367054],
        [106.930025538848, 47.9937830761281],
        [106.930009742256, 47.9937524281321],
        [106.929992114644, 47.9937288353175],
        [106.929972708174, 47.9937137051235],
        [106.929942790428, 47.9936973446568],
        [106.929906804056, 47.9936867083749],
        [106.929864383934, 47.99367196399],
        [106.929832426525, 47.9936570433379],
        [106.929813073115, 47.9936433160862],
        [106.929808385848, 47.9936356070976],
        [106.929803865856, 47.9936209877185],
        [106.929796333134, 47.9935873899461],
        [106.929780273041, 47.9935497191442],
        [106.929761441238, 47.9934938280778],
        [106.929741040117, 47.9934520149985],
        [106.929729637613, 47.9934269131216],
        [106.929722364795, 47.9934003363565],
        [106.929719172202, 47.9933708799622],
        [106.929711554045, 47.9933279742067],
        [106.929701835072, 47.9932943026899],
        [106.92968330544, 47.9932441367076],
        [106.929653960562, 47.9931729652602],
        [106.929645093247, 47.9931457122049],
        [106.929639207184, 47.9931141936652],
        [106.929634969578, 47.9930847561566],
        [106.92963320241, 47.9930373600861],
        [106.929636534399, 47.9930004177351],
        [106.92964198519, 47.9929781954874],
        [106.929651987449, 47.9929516780775],
        [106.929669677114, 47.9929208187409],
        [106.929697840283, 47.9928760810663],
        [106.929721610264, 47.9928398491797],
        [106.929742594145, 47.9928131492075],
        [106.929774170242, 47.9927757311152],
        [106.929795234163, 47.9927511382545],
        [106.929824104199, 47.9927253591881],
        [106.929868233033, 47.9926877306543],
        [106.929930638788, 47.9926350411742],
        [106.929976851351, 47.9926014676836],
        [106.930039333548, 47.9925604954706],
        [106.930098476564, 47.9925242482955],
        [106.930160697059, 47.9924888977445],
        [106.930226910544, 47.9924540598071],
        [106.93028225752, 47.9924225664483],
        [106.930317836499, 47.9924082672278],
        [106.930364437569, 47.9923948376517],
        [106.930412685297, 47.9923834873081],
        [106.930453206051, 47.9923754293826],
        [106.930482702914, 47.9923665009133],
        [106.930510278826, 47.992348122368],
        [106.930536285421, 47.9923297681044],
        [106.930587903809, 47.9922825294153],
        [106.930618304491, 47.9922556711623],
        [106.930634698233, 47.9922322087495],
        [106.930644818304, 47.992208853356],
        [106.930658192122, 47.9921886042208],
        [106.930671566839, 47.9921683550856],
        [106.930698788418, 47.9921404958872],
        [106.930711753045, 47.9921223142934],
        [106.930725460512, 47.9920978914046],
        [106.930742794045, 47.9920575523142],
        [106.930751187417, 47.9920300087779],
        [106.930759737272, 47.9920066803641],
        [106.93077134752, 47.9919811908793],
        [106.930786171944, 47.9919577563454],
        [106.93080119422, 47.9919395864428],
        [106.930822454193, 47.9919202591127],
        [106.930849871824, 47.9918976663443],
        [106.930893306381, 47.991855481845],
        [106.930952415222, 47.9917986312019],
        [106.930987245065, 47.9917643211665],
        [106.931022273659, 47.9917352757624],
        [106.931057339125, 47.991707285263],
        [106.931117037921, 47.9916662330103],
        [106.931210549427, 47.9916056420868],
        [106.931283700283, 47.9915464469111],
        [106.931327710406, 47.991505659059],
        [106.931349562133, 47.9914826328173],
        [106.931360813551, 47.9914671617801],
        [106.931370930924, 47.9914438054873],
        [106.931379441208, 47.9914194230679],
        [106.931384695048, 47.991391933491],
        [106.931407749168, 47.9912524297559],
        [106.931418998788, 47.9911753056958],
        [106.931422095154, 47.9911320438088],
        [106.931420236255, 47.991104356381],
        [106.931415263903, 47.9910752480243],
        [106.931407965905, 47.991047969788],
        [106.931396236048, 47.9910281433342],
        [106.931381368455, 47.991008369041],
        [106.931353515552, 47.990977221022],
        [106.931320443883, 47.9909324590658],
        [106.931298789108, 47.9908990978151],
        [106.931276976052, 47.9908615250394],
        [106.9312583412, 47.9908249514104],
        [106.931247785857, 47.9907945660165],
        [106.931242371938, 47.9907756874481],
        [106.93123687798, 47.9907547008688],
        [106.931231307579, 47.9907316089766],
        [106.9312193412, 47.9907054629868],
        [106.931201295404, 47.9906846877482],
        [106.931173679022, 47.9906598592651],
        [106.931128488089, 47.9906268937162],
        [106.931077218639, 47.9905993007172],
        [106.931025869149, 47.9905696024053],
        [106.930961890479, 47.9905380065238],
        [106.93087880841, 47.9904993563603],
        [106.930800432494, 47.9904606252577],
        [106.930714331401, 47.9904251856738],
        [106.930669768195, 47.99040907342],
        [106.930641015071, 47.9903958551846],
        [106.930616891656, 47.9903804533953],
        [106.930587330041, 47.9903597177268],
        [106.930561403486, 47.9903384631496],
        [106.930531934501, 47.9903184712205],
        [106.930487931573, 47.9902939044402],
        [106.930396068524, 47.9902376032828],
        [106.930364804492, 47.9902176410313],
        [106.930340761117, 47.9901987633623],
        [106.930318198026, 47.9901714257707],
        [106.930298954333, 47.9901368009727],
        [106.930281190025, 47.9900937153527],
        [106.930269166089, 47.9900601742377],
        [106.930264726136, 47.9900373521422],
        [106.930262127096, 47.990002621224],
        [106.930264135282, 47.9899252858233],
        [106.930262159471, 47.9898722950704],
        [106.930266598525, 47.9898469135043],
        [106.93028032128, 47.9898298101976],
        [106.930297543297, 47.9898102391513],
        [106.930311177019, 47.9897907283595],
        [106.930317455186, 47.9897665204086],
        [106.930321759342, 47.9897375253665],
        [106.930326414233, 47.9897099296696],
        [106.930341781848, 47.989672714824],
        [106.930359900489, 47.9896450948453],
        [106.930383102998, 47.9896254230749],
        [106.930420718042, 47.9896071164753],
        [106.93045851295, 47.9895936248459],
        [106.930503425093, 47.9895784092163],
        [106.930536256643, 47.989560181757],
        [106.930549462288, 47.9895487738569],
        [106.930563943171, 47.9895323999004],
        [106.930586545833, 47.9894966698355],
        [106.930604066425, 47.9894529924617],
        [106.93061138151, 47.9894244848521],
        [106.930620207457, 47.9893723799315],
        [106.930633895138, 47.9892902016815],
        [106.930642476469, 47.9892495280433],
        [106.930643580837, 47.9892289803332],
        [106.930637657902, 47.9891985499731],
        [106.930624079038, 47.9891553942061],
        [106.930606017054, 47.9891203485253],
        [106.930592378835, 47.9890755874685],
        [106.930581131914, 47.9890307850428],
        [106.930572839265, 47.9889831668397],
        [106.930566244537, 47.9889204328318],
        [106.930563155365, 47.9888376439422],
        [106.930564686012, 47.9887586672787],
        [106.930578756804, 47.9885580213357],
        [106.930578503195, 47.9885005573549],
        [106.93057418645, 47.9884489668464],
        [106.9305672212, 47.9883993899199],
        [106.930557807097, 47.9883521188552],
        [106.930538134427, 47.9882810346421],
        [106.930524433256, 47.9882479989461],
        [106.930510382248, 47.9882215139118],
        [106.930470085426, 47.9881679170158],
        [106.930433723138, 47.9881223114955],
        [106.930407779496, 47.9880946933155],
        [106.930387606803, 47.9880775549353],
        [106.930328890966, 47.9880331751909],
        [106.930291444994, 47.9880008121878],
        [106.930267225352, 47.9879770799783],
        [106.930244437431, 47.987949301719],
        [106.930208960075, 47.9878980763352],
        [106.930145911305, 47.987804869699],
        [106.930109868276, 47.987751199958],
        [106.930086475111, 47.9876944635287],
        [106.930064697128, 47.9876555390719],
        [106.930023107081, 47.9875926908501],
        [106.929964629564, 47.9875079783106],
        [106.929921287637, 47.9874475582583],
        [106.929873922144, 47.9873969363196],
        [106.929821533937, 47.9873399714626],
        [106.92973242641, 47.9872611269994],
        [106.929621657813, 47.9871601547174],
        [106.92948699333, 47.987033870117],
        [106.929423360899, 47.9869753494329],
        [106.929392683226, 47.9869438659667],
        [106.92935757819, 47.9869010717271],
        [106.92932486625, 47.9868582370181],
        [106.929301961416, 47.9868216651877],
        [106.929276005184, 47.9867674702426],
        [106.929254834243, 47.9867131943585],
        [106.929241258078, 47.9866700376921],
        [106.92923276488, 47.9866348301334],
        [106.929231508527, 47.9866011091539],
        [106.929237426066, 47.9865672658667],
        [106.929257697685, 47.9865331824604],
        [106.929280121381, 47.9864926347274],
        [106.929290643448, 47.9864538955309],
        [106.929296338855, 47.9864105041415],
        [106.929294743458, 47.9863676820229],
        [106.929284854513, 47.9863307126923],
        [106.929275268639, 47.9863091082788],
        [106.929257318171, 47.9862769008583],
        [106.929207668399, 47.9862006077719],
        [106.929137233497, 47.9861038569075],
        [106.929051171075, 47.9859975651356],
        [106.928982340563, 47.9859191433538],
        [106.9289003116, 47.9858315619771],
        [106.928830859656, 47.9857607133862],
        [106.928767739839, 47.9856995298095],
        [106.928623243068, 47.9855710319776],
        [106.928207872296, 47.9851892850575],
        [106.928062165936, 47.9850585362225],
        [106.927770138081, 47.9848110706744],
        [106.927666617121, 47.9847202463424],
        [106.927521186853, 47.984585572866],
        [106.927486760805, 47.9845542413852],
        [106.927471515498, 47.984537130884],
        [106.927460982638, 47.9845212020918],
        [106.927451024445, 47.9845010536807],
        [106.927440261359, 47.9844690980705],
        [106.927432366211, 47.9844285242571],
        [106.927427663656, 47.9843878982829],
        [106.927425988219, 47.9843429348786],
        [106.927420965505, 47.984293742862],
        [106.927414163033, 47.9842719693759],
        [106.927403265049, 47.9842469070692],
        [106.927388462208, 47.984220011944],
        [106.927369299454, 47.9841917741311],
        [106.927347936058, 47.9841655813765],
        [106.927318218861, 47.98413407183],
        [106.927278775495, 47.9840958038783],
        [106.927245585116, 47.9840688763776],
        [106.927214135824, 47.9840485984641],
        [106.927160752966, 47.9840188821657],
        [106.927123902346, 47.9839975484481],
        [106.927102153142, 47.9839877287507],
        [106.927057025162, 47.9839756319699],
        [106.927018436152, 47.9839677089427],
        [106.92697362923, 47.983964177305],
        [106.926925471433, 47.9839564152564],
        [106.926873888119, 47.9839422842091],
        [106.9268377003, 47.9839286378964],
        [106.926786345414, 47.9839051889733],
        [106.92672676263, 47.983875497856],
        [106.926669143067, 47.9838428830427],
        [106.926616841194, 47.9838094822219],
        [106.926583833377, 47.9837800420154],
        [106.926560314307, 47.9837483004438],
        [106.926539824154, 47.9837122223412],
        [106.926524555464, 47.9836881295036],
        [106.926512875969, 47.9836741108716],
        [106.926496067639, 47.9836595247673],
        [106.926453796805, 47.9836301106412],
        [106.926414331856, 47.9835986370675],
        [106.926361950843, 47.9835630949609],
        [106.926300161124, 47.9835319955052],
        [106.926244910374, 47.9835050707025],
        [106.926208873641, 47.9834799661276],
        [106.926178658219, 47.9834570693883],
        [106.926159522444, 47.9834400883894],
        [106.926129465303, 47.9834041712655],
        [106.926116820835, 47.9833844338446],
        [106.926108975149, 47.983368093163],
        [106.926103621485, 47.9833499853136],
        [106.926101241879, 47.9833318010218],
        [106.926106186351, 47.9832931553549],
        [106.926120379452, 47.9832457844655],
        [106.926134253293, 47.9831898475335],
        [106.926139276906, 47.983153342253],
        [106.926140053021, 47.9831323017144],
        [106.926138001667, 47.9831190852776],
        [106.926131805339, 47.9831052483086],
        [106.926120940629, 47.9830893770731],
        [106.926107252048, 47.983074754996],
        [106.926084586435, 47.9830557082544],
        [106.926028937286, 47.983018077922],
        [106.925927604376, 47.9829533627076],
        [106.925876936571, 47.9829156208593],
        [106.925776363588, 47.9828337807544],
        [106.925663333196, 47.9827481787855],
        [106.925612048457, 47.9827058476968],
        [106.925555842628, 47.9826532310618],
        [106.925533041217, 47.9826297560584],
        [106.92552251825, 47.9826152257121],
        [106.925516307532, 47.9826004489516],
        [106.925511675124, 47.9825811288161],
        [106.925510162464, 47.9825404479834],
        [106.92551152044, 47.9824911498467],
        [106.925516497289, 47.9824622051667],
        [106.925530737154, 47.9824072727775],
        [106.925573739137, 47.9822307340612],
        [106.925609117567, 47.9821124471318],
        [106.925633077305, 47.9820475178787],
        [106.925687814541, 47.9819118812284],
        [106.925739561532, 47.981782971507],
        [106.925763479901, 47.9817156518559],
        [106.925788915426, 47.981627386095],
        [106.925799998671, 47.9815822086521],
        [106.925804623884, 47.9815349978419],
        [106.92579944289, 47.9814815250524],
        [106.925794425572, 47.9814154716467],
        [106.925795459793, 47.981374469756],
        [106.925803274901, 47.9813272058859],
        [106.925817387063, 47.9812776928113],
        [106.925840191172, 47.9812044682117],
        [106.925860080578, 47.981128107676],
        [106.925896607443, 47.9809603094707],
        [106.925914743171, 47.980892566239],
        [106.925951976902, 47.980778393708],
        [106.925965851643, 47.9807224576753],
        [106.925973186513, 47.9806623469898],
        [106.925977573406, 47.9806087132216],
        [106.925980101401, 47.9805385040488],
        [106.925978852242, 47.9804715765021],
        [106.925968331973, 47.9803603456535],
        [106.925961685983, 47.9802622323162],
        [106.925956616505, 47.9802170009139],
        [106.925940753363, 47.9801337120012],
        [106.925911418377, 47.9800313682531],
        [106.9258761029, 47.9799398361546],
        [106.925823808222, 47.9798207371373],
        [106.925785703048, 47.9797399645278],
        [106.925764657113, 47.9796888992234],
        [106.925753338246, 47.9796419555119],
        [106.925745527634, 47.9796035229842],
        [106.925744093215, 47.9795649834373],
        [106.925755493921, 47.9795283702381],
        [106.925769687021, 47.979481000248],
        [106.925771964105, 47.9794572968169],
        [106.925771123239, 47.9794338424979],
        [106.925759804372, 47.9793868978871],
        [106.925745057289, 47.9793335851768],
        [106.925714260905, 47.9792267106442],
        [106.925703765816, 47.9791671683302],
        [106.925701775617, 47.979113640682],
        [106.925700022838, 47.9790665368912],
        [106.925704423221, 47.9790474838544],
        [106.925711424443, 47.9790299254907],
        [106.925735661172, 47.9789952395387],
        [106.925763005958, 47.9789583592409],
        [106.92578405459, 47.9789237281476],
        [106.925793550532, 47.9788965452394],
        [106.925800718129, 47.9788570335253],
        [106.92580391342, 47.9788254817106],
        [106.925804547442, 47.9787884107566],
        [106.925798807969, 47.9787199498658],
        [106.925789489194, 47.9786773237995],
        [106.925765569026, 47.9785983894042],
        [106.925703555375, 47.9783846583254],
        [106.92567890226, 47.9783119436414],
        [106.925653572854, 47.9782467670747],
        [106.925661503076, 47.9781701835072],
        [106.925671657321, 47.9781000219984],
        [106.925676867993, 47.978068509754],
        [106.925679897809, 47.978035605359],
        [106.925683035544, 47.9780055572107],
        [106.925682132624, 47.9779812890054],
        [106.925693773449, 47.9779510978649],
        [106.925696698044, 47.9779153390217],
        [106.925689151833, 47.9778840408159],
        [106.92568890362, 47.9778241171893],
        [106.925739926656, 47.9777375637376],
        [106.925787442337, 47.9776425009007],
        [106.925809156467, 47.9775899328292],
        [106.925825231849, 47.9775433146723],
        [106.925836812419, 47.9774989034517],
        [106.925849869676, 47.9774336387515],
        [106.925862944919, 47.9773562916596],
        [106.925873867185, 47.9773195975214],
        [106.925885987349, 47.977289490018],
        [106.925922021384, 47.9772288981952],
        [106.925975674937, 47.9771273044815],
        [106.92602777806, 47.9770277783094],
        [106.924940600229, 47.9769110238247],
        [106.924206477347, 47.9767964313103],
        [106.923214913637, 47.97660071635],
        [106.922160266983, 47.97638511648],
        [106.920800633243, 47.9761118062149],
        [106.919709733118, 47.9758788458321],
        [106.919153270407, 47.9757655366503],
        [106.918747145564, 47.9756227980537],
        [106.918570235428, 47.975536037758],
        [106.918350831426, 47.9753841962237],
        [106.918261500868, 47.9752570959383],
        [106.918174208173, 47.9749445491517],
        [106.917936694523, 47.9740633214652],
        [106.917886120248, 47.9737800664969],
        [106.917732669827, 47.9732443340588],
        [106.917595364934, 47.9726634754391],
        [106.917387233034, 47.9718535271186],
        [106.917281863967, 47.9712930678209],
        [106.917203424199, 47.970738140253],
        [106.917188902846, 47.9704662437222],
        [106.917179521118, 47.9700925844053],
        [106.917179445575, 47.9693688783711],
        [106.917195377065, 47.9687166774328],
        [106.917222691274, 47.9678908353938],
        [106.917263392791, 47.96742662334],
        [106.917287670889, 47.9667593308785],
        [106.917303293013, 47.9659785412767],
        [106.917320193972, 47.9654728587855],
        [106.917311882437, 47.9647672327217],
        [106.917344174394, 47.964075882496],
        [106.917319760499, 47.9637772365303],
        [106.917270883245, 47.9634191876454],
        [106.917220655209, 47.9631448980187],
        [106.917109865028, 47.9625576137429],
        [106.916951813675, 47.961896354833],
        [106.916745177348, 47.9611252572249],
        [106.916640700408, 47.9607083261284],
        [106.916341486071, 47.9596008434042],
        [106.916031618365, 47.9584456885178],
        [106.915833275585, 47.9575368849194],
        [106.915699161487, 47.9569200821961],
        [106.915435970394, 47.9560632000567],
        [106.915279951509, 47.9554557340949],
        [106.915046009965, 47.9546671437737],
        [106.914938247802, 47.9541605511686],
        [106.914728140092, 47.9532938088623],
        [106.914621047024, 47.9528051478393],
        [106.914424599116, 47.9520667711646],
        [106.914331486909, 47.9517154402154],
        [106.914143834371, 47.9509739249067],
        [106.914051280642, 47.9506375379921],
        [106.913872975657, 47.9499078289832],
        [106.913737880399, 47.9493837463629],
        [106.913723243033, 47.9492284829082],
        [106.913705184647, 47.9489805694977],
        [106.913723478656, 47.9486941821908],
        [106.913727749536, 47.9486273095028],
        [106.913794613231, 47.9481477091495],
        [106.913913092615, 47.9476193988162],
        [106.914023212801, 47.9467443269892],
        [106.914169061253, 47.9457520267347],
        [106.914285863402, 47.9448170321804],
        [106.914396130177, 47.9441871802942],
        [106.91456857518, 47.9430718240055],
        [106.914684198317, 47.9423461844289],
        [106.914803304529, 47.9414739508622],
        [106.914857610091, 47.9408958711476],
        [106.914848856989, 47.9407793864595],
        [106.91481297404, 47.9406513913487],
        [106.914779000351, 47.9404545819134],
        [106.914785056385, 47.9402571051813],
        [106.914790452318, 47.9400416959675],
        [106.914780815183, 47.9399013019036],
        [106.914495318204, 47.9398533203745],
        [106.914017295262, 47.9397544381169],
        [106.91351868414, 47.9396703982703],
        [106.913147932331, 47.9396206801503],
        [106.912759733675, 47.9395882640871],
        [106.912596806198, 47.9395836874373],
        [106.912375867053, 47.9395752158236],
        [106.912128817891, 47.9395453070703],
        [106.911702504167, 47.9394600549376],
        [106.911424928418, 47.9393869067804],
        [106.911158375659, 47.9393184350977],
        [106.910861831408, 47.9392212993235],
        [106.910582019944, 47.9390874289417],
        [106.910430778258, 47.9390073155353],
        [106.910267619655, 47.9388982367643],
        [106.910088838929, 47.9387578238146],
        [106.9099347356, 47.9385999873995],
        [106.909835746323, 47.9384655378544],
        [106.909693238852, 47.9382297383118],
        [106.909580633839, 47.9380201746914],
        [106.909479773073, 47.9378207842019],
        [106.909436430247, 47.9377382282367],
        [106.909262990595, 47.9373498353267],
        [106.908833181206, 47.9367761398071],
        [106.908285522859, 47.9360464334962],
        [106.907681879016, 47.9352690478283],
        [106.907270445475, 47.9347023328464],
        [106.906789277603, 47.9341076111774],
        [106.906451888844, 47.9336854819995],
        [106.906144672339, 47.9332968741515],
        [106.905942851881, 47.9330207409145],
        [106.905774812658, 47.9327780687529],
        [106.905587006335, 47.9324895509521],
        [106.90538376405, 47.9321745553115],
        [106.905229336964, 47.9318101419246],
        [106.905080444307, 47.9313994611163],
        [106.905006289808, 47.93115280226],
        [106.904936908911, 47.9309376556483],
        [106.904892293545, 47.9307075173381],
        [106.90487185825, 47.9305450260322],
        [106.904866550451, 47.930302084074],
        [106.904884754528, 47.9300101461514],
        [106.90491036632, 47.929722944958],
        [106.904933835029, 47.9293774533069],
        [106.904976211983, 47.9292115382819],
        [106.904978095163, 47.9292041674385],
        [106.905051353937, 47.9290328304008],
        [106.905108507652, 47.9289152269562],
        [106.905162939118, 47.928821972656],
        [106.905218707877, 47.9287651498918],
        [106.905292904644, 47.9287177430295],
        [106.905427999902, 47.9286547437215],
        [106.905577284664, 47.928584217088],
        [106.905843594606, 47.9284509897215],
        [106.906031825409, 47.9283579440639],
        [106.906235225076, 47.9282840881402],
        [106.906417477185, 47.9282251654591],
        [106.906535751524, 47.9281964671932],
        [106.906625650453, 47.9281828226792],
        [106.906826944808, 47.9281918851474],
        [106.911379965913, 47.9285645704986],
        [106.911571345241, 47.9285765251865],
        [106.912409703145, 47.9286455040868],
        [106.912882557684, 47.9286904072366],
        [106.913167470103, 47.928734670069],
        [106.913364723803, 47.9287596577321],
        [106.914361111476, 47.9288888894108],
        [106.914719410373, 47.926252608671],
        [106.914861728086, 47.9254736051228],
        [106.915014190153, 47.924741556078],
        [106.915096031157, 47.9242236940683],
        [106.915189131673, 47.9237829300383],
        [106.915285538097, 47.9232799050436],
        [106.915434351614, 47.9225252965053],
        [106.915607827239, 47.9217551962454],
        [106.915742689574, 47.9210027038118],
        [106.915900872228, 47.9202743293968],
        [106.916035288498, 47.9195859361421],
        [106.916177849029, 47.9188144653154],
        [106.916258868052, 47.9184266821457],
        [106.916332104343, 47.9180559941888],
        [106.916362728057, 47.9177463378233],
        [106.916371729372, 47.9176104664499],
        [106.916388888437, 47.9168333334916],
        [106.91440155219, 47.9167746428355],
        [106.914166945148, 47.9167668636999],
        [106.913170765219, 47.9167377985107],
        [106.912250372956, 47.9167047763044],
        [106.911613986596, 47.9166787715081],
        [106.911388434828, 47.9166583470052],
        [106.910988553979, 47.9166247060654],
        [106.910893433585, 47.9166100588072],
        [106.910855497483, 47.9165927801328],
        [106.910796523541, 47.9165830161933],
        [106.910566482357, 47.9165581868109],
        [106.91008549435, 47.9165196247809],
        [106.908342740425, 47.916365924348],
        [106.90702798915, 47.9162588177903],
        [106.904820379257, 47.9160698009806],
        [106.901559907864, 47.9157943062623],
        [106.894750001212, 47.9151666667083],
        [106.894757143627, 47.9155364193703],
        [106.89475989915, 47.9156224808928],
        [106.894764793261, 47.9156927799979],
        [106.894776035686, 47.9157457698515],
        [106.894794308111, 47.9158002094122],
        [106.894821711353, 47.9158498052244],
        [106.894856147293, 47.9159008480457],
        [106.894902322085, 47.9159548262543],
        [106.894955472917, 47.9160086893496],
        [106.895235792498, 47.91623084168],
        [106.895922754032, 47.9167575152472],
        [106.896739405, 47.917394648944],
        [106.897273584309, 47.9178143580463],
        [106.897817129157, 47.9182354736882],
        [106.89815459346, 47.9184926474178],
        [106.898241161301, 47.9185694153463],
        [106.898296644075, 47.9186232379721],
        [106.898344921481, 47.9186709245236],
        [106.898383785683, 47.9187156370171],
        [106.898427583566, 47.9187680890761],
        [106.898498677672, 47.9188670100046],
        [106.898780461349, 47.9193190371439],
        [106.89915810826, 47.9199743632263],
        [106.899427533454, 47.9204062608403],
        [106.899731694062, 47.9208970172835],
        [106.899798369799, 47.9210022649426],
        [106.899837808668, 47.9210626076533],
        [106.899871909161, 47.9211042723443],
        [106.899924956572, 47.9211550066983],
        [106.900013571269, 47.921223919948],
        [106.900107007233, 47.9212974458205],
        [106.900361111576, 47.9214722218656],
        [106.900091324855, 47.9216421748466],
        [106.900030941675, 47.9216901662682],
        [106.899989631316, 47.9217287040165],
        [106.899955275416, 47.9217733904297],
        [106.899834303111, 47.9219328690067],
        [106.899761604614, 47.9220369322587],
        [106.899725867355, 47.9220948611889],
        [106.899629880914, 47.9222597051213],
        [106.899517355941, 47.9224356844593],
        [106.899404693372, 47.9226006372097],
        [106.899290690813, 47.9227563197484],
        [106.899174639598, 47.9229037033433],
        [106.899024406951, 47.9230797744121],
        [106.898849128185, 47.923270715771],
        [106.898722142113, 47.92340289183],
        [106.898620880249, 47.9235023172782],
        [106.89848772303, 47.9236241232547],
        [106.898365479983, 47.9237271334005],
        [106.898295477654, 47.9237812851782],
        [106.898214705045, 47.9238398553251],
        [106.897951150625, 47.9240196702716],
        [106.897781298368, 47.9241332429548],
        [106.897357435297, 47.9244091945288],
        [106.897156560027, 47.9245443689275],
        [106.896694337274, 47.9248601029114],
        [106.896470128194, 47.9250096934426],
        [106.896271359136, 47.9251383288708],
        [106.895791942244, 47.9254439994411],
        [106.895145192097, 47.9258557918114],
        [106.894903573941, 47.9260115561884],
        [106.894646304883, 47.9261821117151],
        [106.894420326837, 47.9263381647746],
        [106.894249622922, 47.9264621884793],
        [106.893883767922, 47.9267366139036],
        [106.89373399213, 47.9268449192577],
        [106.893496240159, 47.927009293744],
        [106.893161722036, 47.9272340666989],
        [106.89299222681, 47.9273453119367],
        [106.892577756259, 47.9276118503067],
        [106.892368073928, 47.927751924212],
        [106.892250181801, 47.9278348803755],
        [106.892121361112, 47.9279292120635],
        [106.891597303673, 47.9283256952747],
        [106.891484216623, 47.928407757512],
        [106.891378873636, 47.9284813832093],
        [106.891184228869, 47.9286106463643],
        [106.890778697579, 47.9288693579346],
        [106.890607730163, 47.9289811202825],
        [106.89036650591, 47.9291446817817],
        [106.889919684046, 47.9294533920605],
        [106.889376870346, 47.9298276017624],
        [106.889122363107, 47.9300050074252],
        [106.888987537645, 47.9301047233544],
        [106.888883031926, 47.9301853214955],
        [106.888791757933, 47.9302599859097],
        [106.888711492541, 47.9303306582333],
        [106.888640375953, 47.9303984419346],
        [106.888567417552, 47.9304729597593],
        [106.888490896937, 47.9305559195201],
        [106.888404083582, 47.9306546075242],
        [106.888300319804, 47.9307784126937],
        [106.888214214215, 47.9308896507368],
        [106.888136800573, 47.931000492179],
        [106.888042432013, 47.9311475897895],
        [106.887972020492, 47.931264776848],
        [106.887899218574, 47.9313957738959],
        [106.887825368046, 47.931537034007],
        [106.88770308363, 47.9317793572316],
        [106.887624059303, 47.9319430284481],
        [106.887452498334, 47.9323190161098],
        [106.887366679629, 47.9324922471196],
        [106.887335569381, 47.9325510726739],
        [106.887141437228, 47.9329306144563],
        [106.887087296242, 47.9330299382811],
        [106.887035724619, 47.9331180763382],
        [106.88697043204, 47.9332210693969],
        [106.886834455446, 47.9334256183976],
        [106.886739660607, 47.9335738257715],
        [106.886689544987, 47.9336470413779],
        [106.886601398836, 47.9337635008849],
        [106.886514353455, 47.9338671828243],
        [106.886446910597, 47.9339394829208],
        [106.886342965156, 47.9340438078755],
        [106.886227756606, 47.9341562204333],
        [106.886119040262, 47.934257507478],
        [106.885972098234, 47.9343852921476],
        [106.88573212224, 47.9345825143716],
        [106.885444965113, 47.9348109646543],
        [106.885344674517, 47.9348930439788],
        [106.885170278885, 47.9350392143883],
        [106.88506903231, 47.9351269594417],
        [106.884978421117, 47.9352103670648],
        [106.884901008375, 47.9352877798072],
        [106.884811058184, 47.9353884364273],
        [106.884658162644, 47.9355742066844],
        [106.88454444517, 47.9357096194034],
        [106.884482692322, 47.9357871076889],
        [106.88438264904, 47.9359225159114],
        [106.884313657549, 47.9360288697366],
        [106.884280832295, 47.9360896063503],
        [106.884249345231, 47.9361586383106],
        [106.884165207358, 47.9363789830037],
        [106.884135042298, 47.93645184068],
        [106.883980194331, 47.9367875171302],
        [106.883923189903, 47.9369251439803],
        [106.883817203901, 47.9371957472859],
        [106.883726158336, 47.9374180848767],
        [106.883683893797, 47.9375310703027],
        [106.88360206988, 47.9378003677928],
        [106.883550991985, 47.9379462827948],
        [106.883454968672, 47.9382010949047],
        [106.883332031348, 47.9385253841392],
        [106.883232683242, 47.9387616513292],
        [106.883078266949, 47.9391052903769],
        [106.882933387066, 47.9394190755299],
        [106.882733470473, 47.9398496349527],
        [106.882640734183, 47.9400604108593],
        [106.882588586094, 47.9401634201058],
        [106.882524734229, 47.9402727398951],
        [106.882471417022, 47.9403500141419],
        [106.882432620269, 47.9403982870514],
        [106.882393915247, 47.9404418097418],
        [106.882343413818, 47.9404922698025],
        [106.882284492036, 47.9405449934567],
        [106.882219328959, 47.9405967629303],
        [106.882116615589, 47.9406708598723],
        [106.882041076135, 47.9407230034639],
        [106.881895665653, 47.9408193226537],
        [106.881622037927, 47.9410012384164],
        [106.881338163326, 47.9411978050347],
        [106.881179267509, 47.9413099109237],
        [106.881096322138, 47.9413647138106],
        [106.881020598322, 47.9414100612254],
        [106.880934053864, 47.9414580427545],
        [106.88067871565, 47.9415888167705],
        [106.880519894478, 47.9416674597855],
        [106.880418897914, 47.9417136750461],
        [106.880222876285, 47.9417990611778],
        [106.879888680119, 47.941945753194],
        [106.87945908387, 47.9421449449333],
        [106.879326822375, 47.9422048029094],
        [106.87905200035, 47.9423248651005],
        [106.878814767288, 47.9424249920198],
        [106.878594820994, 47.9425137407166],
        [106.878387008354, 47.9425931490546],
        [106.878262826368, 47.9426380360166],
        [106.878122909844, 47.9426864303346],
        [106.877636361329, 47.9428480358082],
        [106.877102441924, 47.9430250754469],
        [106.87615041511, 47.9433358199922],
        [106.875324728653, 47.9436079134745],
        [106.87488804125, 47.9437475125378],
        [106.874783531035, 47.9437832273142],
        [106.874555547501, 47.9438692708502],
        [106.874458742677, 47.9439015960818],
        [106.87439718768, 47.943918899038],
        [106.874338783009, 47.9439323492985],
        [106.874282347852, 47.9439422148614],
        [106.874227277867, 47.9439485982493],
        [106.874055555919, 47.9439444442807],
        [106.865686168182, 47.9477861717945],
        [106.864261969414, 47.9485404242013],
        [106.863683760197, 47.9488378569816],
        [106.863148381193, 47.9491519452061],
        [106.861957426994, 47.94974920746],
        [106.860742861994, 47.9503349377073],
        [106.862789036385, 47.9524225123891],
        [106.862415842917, 47.9527951653646],
        [106.862301980652, 47.9529389165977],
        [106.862194166328, 47.9530734524779],
        [106.862200136028, 47.9532524103705],
        [106.862597375568, 47.9537379507459],
        [106.862643107893, 47.9540012209796],
        [106.86265762385, 47.9541586410085],
        [106.862529903932, 47.9545188581588],
        [106.862569934555, 47.9547454711267],
        [106.862435334823, 47.9549726551639],
        [106.862292612414, 47.9552005667528],
        [106.861782206684, 47.9559394470479],
        [106.867716653901, 47.9644307504788],
        [106.865055556369, 47.9700833330794],
        [106.863655095207, 47.9724000586158],
        [106.863573308162, 47.9724024508125],
        [106.863535003338, 47.9726257668657],
        [106.857540813258, 47.9825120950572],
        [106.856277778397, 47.9835833333042],
        [106.863250000087, 48.0226388887738],
        [106.843583333304, 48.0675833327047],
        [106.841861110002, 48.0796388895232],
        [106.831277778447, 48.1043055548575],
        [106.85900000015, 48.1326666657341],
        [106.867250000187, 48.1426666664336],
        [106.867408275472, 48.1417816696884],
        [106.867475780383, 48.1412903673566],
        [106.867694919985, 48.140834985746],
        [106.868305526379, 48.1399575981647],
        [106.869779179765, 48.1383785199528],
        [106.871248173764, 48.1369979050294],
        [106.874708267672, 48.1344606864116],
        [106.877777349845, 48.1328012870498],
        [106.879143986606, 48.1318552731024],
        [106.880179798759, 48.1310051187913],
        [106.881275415828, 48.1304301255499],
        [106.882650907314, 48.1297667658237],
        [106.884232124113, 48.1292649162429],
        [106.885065515961, 48.1290906195365],
        [106.885278748815, 48.1289681390684],
        [106.885489781928, 48.1286642455585],
        [106.885844853157, 48.1285416742589],
        [106.887075763336, 48.128500157956],
        [106.887017711199, 48.1282982466668],
        [106.886932011203, 48.1280649247565],
        [106.886916648085, 48.1278533925201],
        [106.886828484847, 48.1277132484677],
        [106.886694718786, 48.1275548185001],
        [106.88680943181, 48.1273387671704],
        [106.886895671398, 48.1270732099607],
        [106.887003485722, 48.1268144381358],
        [106.887063635978, 48.1267099351155],
        [106.887013067099, 48.1266394237704],
        [106.886936774912, 48.126574999037],
        [106.886917254228, 48.1264981717533],
        [106.886917546508, 48.1264382472274],
        [106.886967139622, 48.126404546033],
        [106.887063573026, 48.1264172399637],
        [106.887146244104, 48.1264908413793],
        [106.887327671535, 48.1264949998444],
        [106.887460000479, 48.1264978704804],
        [106.88756849469, 48.1265195990003],
        [106.887664200542, 48.1265221198],
        [106.8877451746, 48.1264864364999],
        [106.887731453644, 48.1264513233699],
        [106.887712380822, 48.1263878977833],
        [106.887699725562, 48.1263293231398],
        [106.887693243249, 48.1262744689916],
        [106.887692894312, 48.1262229234492],
        [106.887701106921, 48.1261461860977],
        [106.887708374342, 48.1261153978074],
        [106.88771812659, 48.1260877823253],
        [106.887730458094, 48.1260646589569],
        [106.887748637889, 48.1260401830081],
        [106.887840086351, 48.1259461561902],
        [106.88785856562, 48.1259239762106],
        [106.887872353127, 48.1259033682459],
        [106.8879030308, 48.1258422116488],
        [106.88792799598, 48.1257744639204],
        [106.887946650617, 48.1257037097585],
        [106.887953474673, 48.1256460560207],
        [106.887952557365, 48.1256165825393],
        [106.887948322457, 48.1255841502884],
        [106.887927933927, 48.1254982767242],
        [106.887908787361, 48.1254441474295],
        [106.887878965842, 48.125385731966],
        [106.887841849921, 48.1253268587476],
        [106.887731403282, 48.1251665240159],
        [106.887702374065, 48.1251167348495],
        [106.887680862282, 48.1250712138655],
        [106.887646877801, 48.1249839589426],
        [106.887621149097, 48.1249072296849],
        [106.88760206908, 48.1248362192162],
        [106.887589314895, 48.1247695848485],
        [106.887578090457, 48.1246898077884],
        [106.887573673886, 48.1246347863664],
        [106.887574501262, 48.1245852121379],
        [106.887580926019, 48.124540688502],
        [106.887591259229, 48.1245001182859],
        [106.887603797577, 48.1244631453579],
        [106.887618709236, 48.1244292714937],
        [106.887636076044, 48.1243983204262],
        [106.88767392761, 48.1243471723841],
        [106.887722872313, 48.1242958489743],
        [106.887749271012, 48.1242728901818],
        [106.887779323657, 48.1242502677357],
        [106.887813175937, 48.1242278701201],
        [106.887851106643, 48.1242055120748],
        [106.887939212325, 48.1241606970586],
        [106.888058089209, 48.1241084608368],
        [106.888138800665, 48.1240778901825],
        [106.888232960583, 48.124048639733],
        [106.888332431896, 48.1240222329398],
        [106.888536050998, 48.1239726164432],
        [106.888597793054, 48.123958868507],
        [106.888782235911, 48.123923383957],
        [106.888837879664, 48.1239089318518],
        [106.88888526854, 48.1238927755312],
        [106.888934312169, 48.1238722314184],
        [106.8889808323, 48.123850035251],
        [106.889023951194, 48.1238266052137],
        [106.889063051019, 48.123802280351],
        [106.889108750069, 48.1237683804065],
        [106.889152819547, 48.123728820129],
        [106.889195559827, 48.1236833423125],
        [106.889237871131, 48.1236309981721],
        [106.889264277924, 48.1235917922275],
        [106.889288699914, 48.1235464870808],
        [106.889350137099, 48.1234001179212],
        [106.889373157046, 48.1233421719037],
        [106.88939436216, 48.1232811340172],
        [106.889432384597, 48.1231466152242],
        [106.889460749214, 48.1230192469408],
        [106.889525305249, 48.1226899259993],
        [106.889587262242, 48.1224156984258],
        [106.889614845349, 48.1222833047308],
        [106.889637506466, 48.1221524380846],
        [106.889652169012, 48.1220344182539],
        [106.889659976027, 48.1219070922386],
        [106.88966652579, 48.1216030593338],
        [106.889678850998, 48.1213557017043],
        [106.889691925342, 48.1211984633385],
        [106.889699610948, 48.1210780459151],
        [106.889705784794, 48.121045071373],
        [106.88971542103, 48.1210161959407],
        [106.889733349914, 48.1209815630488],
        [106.889772290559, 48.1209209532395],
        [106.889848527887, 48.1208051808145],
        [106.889906956841, 48.1206994798972],
        [106.889926881321, 48.1206557998253],
        [106.889942158104, 48.1206150254631],
        [106.889957821596, 48.1205530837578],
        [106.889975952828, 48.120439324915],
        [106.890009742156, 48.120222625174],
        [106.89003126563, 48.1200275010684],
        [106.890036888192, 48.1199157818879],
        [106.890037241625, 48.1196408843194],
        [106.890042654645, 48.1195153542503],
        [106.890049264662, 48.1193741202195],
        [106.890055309005, 48.1193344124532],
        [106.890064911966, 48.1192994261277],
        [106.890085635943, 48.1192529644528],
        [106.890140159141, 48.119156726202],
        [106.890185670233, 48.1190540919728],
        [106.890199794085, 48.1190288857745],
        [106.890215158103, 48.1190072930522],
        [106.890243413903, 48.1189761018657],
        [106.89027850365, 48.118944254174],
        [106.890320725022, 48.1189114567983],
        [106.890371332571, 48.1188767339742],
        [106.890410573589, 48.1188533003396],
        [106.890457381503, 48.1188293415009],
        [106.890618487853, 48.1187581502685],
        [106.890739876544, 48.1187050506976],
        [106.890859516054, 48.1186557912318],
        [106.890977642904, 48.1186102729458],
        [106.891094416274, 48.1185684373835],
        [106.891177823898, 48.1185423273666],
        [106.891387261613, 48.1184839307888],
        [106.891443412583, 48.1184657204167],
        [106.89149237887, 48.1184473679517],
        [106.891574681227, 48.1184141137204],
        [106.89162309443, 48.1183927791035],
        [106.891665283426, 48.1183712178575],
        [106.891700054814, 48.1183496404236],
        [106.891747432898, 48.1183148321638],
        [106.891782724993, 48.1182840519675],
        [106.891808939331, 48.1182546693176],
        [106.891826308837, 48.1182263082976],
        [106.891838343565, 48.1181894235032],
        [106.891843449915, 48.1181451903483],
        [106.891842842873, 48.1181119289224],
        [106.891838583684, 48.1180817899427],
        [106.891830676844, 48.1180548201739],
        [106.891819138542, 48.1180310726759],
        [106.891807124499, 48.11801513579],
        [106.891789823342, 48.117998584667],
        [106.891718892013, 48.1179463016805],
        [106.891694533876, 48.1179253429802],
        [106.891649738645, 48.1178759791931],
        [106.891589297009, 48.1177990871582],
        [106.89151010091, 48.1176971741853],
        [106.891488403867, 48.1176635377421],
        [106.891472521839, 48.1176326019631],
        [106.89146102041, 48.1176014764271],
        [106.891452127913, 48.117566025152],
        [106.891435686508, 48.1174513283162],
        [106.891427952338, 48.1173799635146],
        [106.891415744941, 48.1171822043952],
        [106.891407660935, 48.1170487746813],
        [106.891400189367, 48.117012253213],
        [106.89138822119, 48.1169805682986],
        [106.891375264657, 48.1169573657899],
        [106.891357720682, 48.1169321110282],
        [106.891293040541, 48.1168541452027],
        [106.891219981417, 48.1167648434228],
        [106.891193571027, 48.1167376470248],
        [106.891167202904, 48.1167147538828],
        [106.891139553248, 48.1166951603534],
        [106.891105584056, 48.1166751513372],
        [106.890951626416, 48.1165970488148],
        [106.890851459028, 48.1165382439448],
        [106.890766456007, 48.1164855796458],
        [106.890660778472, 48.1164180990161],
        [106.890601396238, 48.1163737777277],
        [106.890537796182, 48.116316098809],
        [106.890515078408, 48.1162913323791],
        [106.890496904908, 48.1162677170815],
        [106.890482141638, 48.1162433769303],
        [106.890469057401, 48.1162154134107],
        [106.890441697327, 48.1161338997597],
        [106.890429888329, 48.1160831348288],
        [106.890424550852, 48.1160261061199],
        [106.890424785575, 48.1159685908778],
        [106.890432311102, 48.1158156197951],
        [106.890431164467, 48.1157703677084],
        [106.890426872902, 48.1157299647661],
        [106.890405550876, 48.1155919314226],
        [106.890393694214, 48.1155475651681],
        [106.890378506463, 48.1155084626455],
        [106.890350670647, 48.1154514968891],
        [106.890324780065, 48.1154150383734],
        [106.890302830311, 48.1153928709842],
        [106.890277623214, 48.1153717818823],
        [106.890250127342, 48.1153525750614],
        [106.890221279788, 48.1153359061272],
        [106.890188654183, 48.1153216509734],
        [106.890148593883, 48.1153091270146],
        [106.890007931821, 48.1152787892847],
        [106.889939729035, 48.1152662941042],
        [106.889768868638, 48.1152431374609],
        [106.889723433989, 48.1152341118648],
        [106.889683996919, 48.1152234908715],
        [106.88960102097, 48.1151933698782],
        [106.889510371107, 48.1151522483776],
        [106.889448797224, 48.1151211210429],
        [106.889403746586, 48.1150958824691],
        [106.8893661873, 48.1150714658755],
        [106.889335511425, 48.1150473424609],
        [106.889310596607, 48.1150232298382],
        [106.889286811337, 48.1149956638189],
        [106.889263829162, 48.1149642837747],
        [106.889240586184, 48.1149276489919],
        [106.889224352522, 48.1148978877274],
        [106.889209809585, 48.1148658223998],
        [106.8891853813, 48.1147938307707],
        [106.889178101288, 48.1147608850069],
        [106.889173446397, 48.1147237268186],
        [106.889167920963, 48.1145920291988],
        [106.889165655571, 48.1145290487767],
        [106.889165504484, 48.1143554778231],
        [106.889162030403, 48.1143026426529],
        [106.889155578667, 48.1142554174536],
        [106.88913858148, 48.1141659744802],
        [106.889119986198, 48.114107802733],
        [106.889102987213, 48.114071332526],
        [106.889082846896, 48.114035481952],
        [106.889059870117, 48.114000793302],
        [106.889034376136, 48.1139677477134],
        [106.889007766096, 48.1139390908164],
        [106.88897396058, 48.1139087027245],
        [106.888837194381, 48.113802582723],
        [106.888676332647, 48.1136743789695],
        [106.888609111022, 48.1136177153853],
        [106.888530375377, 48.1135452435182],
        [106.888442338044, 48.1134587853947],
        [106.888326449606, 48.1133465041379],
        [106.888296779173, 48.1133119198093],
        [106.888274824024, 48.1132796593289],
        [106.888256717973, 48.113244351046],
        [106.888241482558, 48.1132052485235],
        [106.888228892949, 48.1131618292551],
        [106.888218390666, 48.1131121794836],
        [106.888212751018, 48.1130727963725],
        [106.888209873187, 48.1130325121408],
        [106.888209777859, 48.1129916541416],
        [106.888212468631, 48.1129506036875],
        [106.888218540853, 48.1129110649937],
        [106.888229415455, 48.1128673372578],
        [106.888274944533, 48.1127340163618],
        [106.888291232155, 48.1126915746565],
        [106.888312649509, 48.1126447982189],
        [106.888394315146, 48.1124901283168],
        [106.888422603321, 48.1124319682608],
        [106.888445923641, 48.1123735285156],
        [106.888460953111, 48.1123200431355],
        [106.888470528192, 48.112268002966],
        [106.888477381926, 48.1122136110694],
        [106.888481525102, 48.1121567865065],
        [106.888482969414, 48.1120973826881],
        [106.888484754568, 48.112012905771],
        [106.88848318615, 48.1119707590433],
        [106.888476961942, 48.1119305728377],
        [106.888465513573, 48.1118955811162],
        [106.888448359904, 48.1118626740233],
        [106.888424285952, 48.1118275797791],
        [106.888392937384, 48.1117895879192],
        [106.888349256413, 48.1117425569735],
        [106.888303262386, 48.1117002447705],
        [106.888183228973, 48.111603823058],
        [106.888069469231, 48.1115035855221],
        [106.888034864218, 48.1114697431342],
        [106.888006163254, 48.1114383262178],
        [106.887973869499, 48.1113987056858],
        [106.887945421244, 48.1113599898717],
        [106.887920787914, 48.1113221392054],
        [106.887899962314, 48.1112851348012],
        [106.887873095067, 48.1112228738366],
        [106.887844025382, 48.1111311187062],
        [106.887821066589, 48.1110239779742],
        [106.887808440108, 48.1109835057842],
        [106.887791519363, 48.1109446838501],
        [106.887773555405, 48.1109099214557],
        [106.887754149834, 48.1108784514794],
        [106.887733137175, 48.1108500167149],
        [106.887706689013, 48.1108214317637],
        [106.887672315125, 48.1107914007026],
        [106.887536218022, 48.1106915804521],
        [106.887454136, 48.1106311208296],
        [106.88725113743, 48.1104899281677],
        [106.887153914422, 48.1104149364003],
        [106.88706111248, 48.1103329820815],
        [106.886924866989, 48.1102031361659],
        [106.886790742998, 48.1100687064057],
        [106.886737019298, 48.1100176051284],
        [106.886669386683, 48.109956584329],
        [106.886622742446, 48.1099184368864],
        [106.886538393232, 48.1098599278934],
        [106.886437361595, 48.1098002272987],
        [106.886333635589, 48.1097467976766],
        [106.886232613844, 48.1097025447367],
        [106.886176479061, 48.1096823450642],
        [106.886018801826, 48.10963195605],
        [106.88590048432, 48.1095899541131],
        [106.885865168843, 48.1095753527204],
        [106.885835148573, 48.1095608709375],
        [106.885782739682, 48.1095307517428],
        [106.885734979386, 48.1094980344068],
        [106.885693499955, 48.1094638421826],
        [106.885659328415, 48.1094290312249],
        [106.885627447449, 48.1093862603677],
        [106.885601750221, 48.1093387132111],
        [106.885582952591, 48.1092876946714],
        [106.885571765025, 48.1092351149087],
        [106.885569300883, 48.1091677916603],
        [106.885564556959, 48.1090471673929],
        [106.885566821452, 48.1090110847938],
        [106.885572456604, 48.1089791228883],
        [106.885584077643, 48.1089413243827],
        [106.885601311351, 48.108900716395],
        [106.885624459901, 48.1088563924087],
        [106.885656522531, 48.1088026003597],
        [106.885677312158, 48.1087730036712],
        [106.885730950423, 48.1087060248632],
        [106.885752363281, 48.1086730359319],
        [106.885774786977, 48.1086279358306],
        [106.885791155537, 48.1085862711395],
        [106.885801793618, 48.1085472063885],
        [106.885806764171, 48.1085104717809],
        [106.885807901813, 48.1084738918567],
        [106.885806060901, 48.1084446611922],
        [106.885800989624, 48.1084189037095],
        [106.885792523406, 48.1083961877339],
        [106.88578150851, 48.1083765231581],
        [106.885767078888, 48.1083563900355],
        [106.885729253402, 48.1083163908888],
        [106.88569480667, 48.1082896387559],
        [106.885652043007, 48.108264104305],
        [106.885601529887, 48.1082401346745],
        [106.885544618989, 48.1082183773763],
        [106.885518116868, 48.1082105649656],
        [106.885487360054, 48.1082039027879],
        [106.885362889386, 48.1081856879192],
        [106.885311694579, 48.1081750462414],
        [106.885221972816, 48.1081473183441],
        [106.885107941478, 48.1081042902808],
        [106.88497349643, 48.1080496492719],
        [106.884929736318, 48.1080282031391],
        [106.884893150998, 48.1080067686975],
        [106.884850202075, 48.1079775173486],
        [106.884816300332, 48.1079510790791],
        [106.88478920286, 48.1079257020096],
        [106.884768585902, 48.1079010318072],
        [106.88475281629, 48.1078753237872],
        [106.884740061205, 48.107846523898],
        [106.884730402486, 48.1078148057087],
        [106.884723946253, 48.1077805109618],
        [106.884722153005, 48.1077529197615],
        [106.884723957045, 48.1077225379648],
        [106.88473912591, 48.1076455353133],
        [106.884757530536, 48.1075868482545],
        [106.884784953563, 48.1075235296872],
        [106.884810496108, 48.1074823209524],
        [106.884884018383, 48.1073882833426],
        [106.884899069437, 48.1073630960301],
        [106.884908979966, 48.1073396138321],
        [106.884922467998, 48.1072878758349],
        [106.884925637208, 48.1072450330319],
        [106.884920886989, 48.1072109424311],
        [106.884909790255, 48.1071753823381],
        [106.88489265727, 48.1071393896711],
        [106.884870206595, 48.1071044797879],
        [106.884850626555, 48.10708205879],
        [106.884823955361, 48.1070587861341],
        [106.884725550644, 48.1069901085067],
        [106.884694152613, 48.1069659050525],
        [106.884588177403, 48.1068752911618],
        [106.884555003211, 48.1068434218865],
        [106.884527659324, 48.1068137010915],
        [106.88448304036, 48.1067587929839],
        [106.884450162045, 48.1067116846966],
        [106.884425994564, 48.1066680163159],
        [106.884410194375, 48.1066270108279],
        [106.884398427645, 48.106577876368],
        [106.884393502958, 48.1065337151589],
        [106.884395369051, 48.1064940100906],
        [106.884404039415, 48.1064587045056],
        [106.884423629347, 48.1064168626481],
        [106.884450680954, 48.106377275391],
        [106.884483118601, 48.1063429392753],
        [106.884519491681, 48.1063153480749],
        [106.884545244667, 48.1063015479781],
        [106.88457760767, 48.1062885284928],
        [106.884698208556, 48.106251790288],
        [106.884863217963, 48.1062015577558],
        [106.884936800493, 48.106182153084],
        [106.885006859479, 48.1061658897441],
        [106.885086796618, 48.1061515266717],
        [106.885274189252, 48.1061269041334],
        [106.885356947565, 48.106112990722],
        [106.885505118966, 48.1060806322155],
        [106.885626129043, 48.1060479463557],
        [106.885747435895, 48.1060095408077],
        [106.885789026842, 48.1059935787407],
        [106.88582470025, 48.1059773234948],
        [106.885878646083, 48.1059496684425],
        [106.88591432039, 48.1059286045215],
        [106.885942217359, 48.1059079497921],
        [106.885962221879, 48.1058874938128],
        [106.885975136144, 48.1058675072797],
        [106.885985123115, 48.1058438002512],
        [106.885992443596, 48.1058160867431],
        [106.885998487041, 48.1057791174124],
        [106.886002043859, 48.1057229646432],
        [106.885999786561, 48.1056994410764],
        [106.885994790827, 48.1056781334391],
        [106.885986505373, 48.1056576702653],
        [106.885973949039, 48.1056355847145],
        [106.885930784278, 48.1055781387202],
        [106.885888049394, 48.105529101387],
        [106.885847168912, 48.1054919405007],
        [106.885797571301, 48.1054558821833],
        [106.88575448748, 48.1054328343579],
        [106.885711432437, 48.1054186520492],
        [106.885632635638, 48.1054011530408],
        [106.885574481877, 48.1053894519617],
        [106.885512682265, 48.1053801044084],
        [106.885446573101, 48.1053730069588],
        [106.885374825188, 48.1053680148221],
        [106.885257214549, 48.1053642079918],
        [106.884980340271, 48.1053632322274],
        [106.884856688885, 48.1053599964667],
        [106.88478722525, 48.1053581177829],
        [106.884618462972, 48.1053580935012],
        [106.884542302086, 48.1053563874874],
        [106.884462834392, 48.105350734349],
        [106.884393330288, 48.1053406520495],
        [106.8843284469, 48.1053273897473],
        [106.884272768973, 48.1053138234742],
        [106.884223509507, 48.1052992706449],
        [106.884180029984, 48.1052835235158],
        [106.884131782256, 48.1052615944471],
        [106.88408260283, 48.1052342172853],
        [106.884031596881, 48.1052009504635],
        [106.883974322657, 48.1051589071579],
        [106.88391741086, 48.105113699138],
        [106.883875343272, 48.1050759500951],
        [106.88384233006, 48.1050404556525],
        [106.883817888285, 48.1050065377216],
        [106.883800312834, 48.1049713913167],
        [106.883787266369, 48.1049308426843],
        [106.883778310021, 48.1048845329948],
        [106.883770790789, 48.1048186918292],
        [106.883767716907, 48.1047368724088],
        [106.883774937563, 48.1046569532559],
        [106.883780669842, 48.1046301210833],
        [106.883789869007, 48.1046007950907],
        [106.883840309283, 48.1044801492395],
        [106.883857032176, 48.1044265721286],
        [106.883864714185, 48.1043845629972],
        [106.88387014609, 48.1043374610051],
        [106.883878328122, 48.1041837147067],
        [106.883886189996, 48.1040034869714],
        [106.883886126144, 48.103846772011],
        [106.883881908323, 48.1037941256984],
        [106.883865640487, 48.103686645922],
        [106.883860699612, 48.103641021516],
        [106.883860008932, 48.103593244133],
        [106.883865246584, 48.1035507160927],
        [106.883884595498, 48.1034768934439],
        [106.883896669796, 48.1034447975394],
        [106.883910582308, 48.103415245817],
        [106.883946689188, 48.1033555218399],
        [106.883966307, 48.1033296087745],
        [106.883987054359, 48.1033062111128],
        [106.88401245661, 48.1032833881179],
        [106.884045244992, 48.1032602080922],
        [106.884169283985, 48.1031893954743],
        [106.884213063882, 48.1031610416488],
        [106.884305774092, 48.10309768531],
        [106.884343137326, 48.1030696723276],
        [106.884376090284, 48.1030392113905],
        [106.884398621, 48.103009799063],
        [106.884408500952, 48.1029901317892],
        [106.884416296275, 48.1029671532116],
        [106.884434149616, 48.1028812256881],
        [106.884465097986, 48.1027832220681],
        [106.884469421926, 48.1027562981647],
        [106.884468938091, 48.1027324571372],
        [106.884462887452, 48.1027070198132],
        [106.88445069984, 48.1026789213952],
        [106.884393164813, 48.102585499821],
        [106.88435866592, 48.1025308741006],
        [106.884277539877, 48.1024162348214],
        [106.884244327913, 48.1023656434597],
        [106.884162656881, 48.1022336661508],
        [106.884141086642, 48.1021909933198],
        [106.884125890797, 48.1021520238968],
        [106.884114516172, 48.1021103250315],
        [106.884106327845, 48.1020648849865],
        [106.884101153146, 48.1020148844794],
        [106.884098651232, 48.1019571174271],
        [106.884099338314, 48.1019098220807],
        [106.884103266553, 48.1018597469298],
        [106.884121175652, 48.1017479225287],
        [106.884134052145, 48.1016944965039],
        [106.884151972935, 48.1016360468661],
        [106.884211839905, 48.1014769819772],
        [106.884250034112, 48.1013919924466],
        [106.884350409244, 48.1011976984151],
        [106.884372313132, 48.1011485594585],
        [106.88438926895, 48.1011035744704],
        [106.884425351549, 48.1009897922452],
        [106.884435714437, 48.1009467551887],
        [106.884442436869, 48.1009073486952],
        [106.884444374009, 48.1008774246535],
        [106.884443632068, 48.1008068179803],
        [106.884447563005, 48.1007725385219],
        [106.884466094435, 48.1007086048183],
        [106.884478694836, 48.1006787113535],
        [106.88449338706, 48.1006505328958],
        [106.884516156995, 48.100615676972],
        [106.884544730255, 48.100580058423],
        [106.884579022304, 48.1005437824696],
        [106.884618877559, 48.1005070109898],
        [106.884653369258, 48.1004801743206],
        [106.884696086155, 48.1004525597379],
        [106.884840139561, 48.1003736972884],
        [106.884884583157, 48.1003477167737],
        [106.885031360609, 48.1002607703184],
        [106.885069684319, 48.1002345568793],
        [106.885100772982, 48.1002094433112],
        [106.885134366258, 48.1001764984467],
        [106.885166843475, 48.1001385020903],
        [106.885198985245, 48.1000946691337],
        [106.88523532595, 48.1000388275299],
        [106.885283271506, 48.0999556564284],
        [106.885298960179, 48.0999213221114],
        [106.88531031322, 48.0998893970781],
        [106.885317815365, 48.0998540627149],
        [106.88532039552, 48.0998140177028],
        [106.885312029127, 48.0996876746465],
        [106.885311500326, 48.0996468697073],
        [106.885311500326, 48.0995143671943],
        [106.885315878225, 48.0994772269925],
        [106.885324213142, 48.0994445717097],
        [106.885341516997, 48.0993994059579],
        [106.88536117258, 48.0993599751828],
        [106.885383689806, 48.0993252460633],
        [106.885409250337, 48.0992949766819],
        [106.885430968964, 48.099274303966],
        [106.885456306463, 48.0992535161369],
        [106.885516850622, 48.0992123748513],
        [106.885554469263, 48.0991929054283],
        [106.885600578404, 48.0991752022738],
        [106.885649708367, 48.0991603256886],
        [106.885783928586, 48.0991243087399],
        [106.885822079625, 48.099111873814],
        [106.885854623392, 48.0990990503809],
        [106.886132892519, 48.0990768362271],
        [106.886182920006, 48.0989113070112],
        [106.886218013351, 48.0988836249793],
        [106.886248017432, 48.0988568197865],
        [106.886296033135, 48.0988049351997],
        [106.886344332125, 48.0987407209076],
        [106.886369865677, 48.0986993323084],
        [106.886393317298, 48.0986517644674],
        [106.88645582018, 48.0984896463801],
        [106.886413885692, 48.0983543415796],
        [106.886147086519, 48.098201602522],
        [106.886064038625, 48.0981172641005],
        [106.886086498293, 48.09800262662],
        [106.886290094912, 48.0978850141821],
        [106.886333341511, 48.0977557510271],
        [106.886327203638, 48.0975880193716],
        [106.88616045674, 48.09740149908],
        [106.886100783125, 48.0972275036464],
        [106.886076052668, 48.0969886589995],
        [106.885993633399, 48.0967757570955],
        [106.886159803832, 48.0966551894854],
        [106.886285050615, 48.096581713975],
        [106.886341928237, 48.0963879514429],
        [106.886516138609, 48.0961958319721],
        [106.886662693029, 48.0961220066254],
        [106.886767673589, 48.0960774317281],
        [106.886827448828, 48.0960045740519],
        [106.886672622444, 48.0958274354878],
        [106.886607287596, 48.0957589467181],
        [106.886504896184, 48.0956628829357],
        [106.88646180247, 48.0956261690125],
        [106.886420233107, 48.0955936099572],
        [106.886337943341, 48.0955372620351],
        [106.886204016302, 48.0954556980221],
        [106.886173804478, 48.0954388231432],
        [106.886138019554, 48.0954213744969],
        [106.885981039294, 48.095354756317],
        [106.885917422151, 48.0953237180152],
        [106.885886413527, 48.0953050390963],
        [106.885860852996, 48.0952861515347],
        [106.885840221649, 48.0952666659239],
        [106.885824297354, 48.0952463691247],
        [106.885803192064, 48.0952110833249],
        [106.885788957594, 48.0951797770251],
        [106.885781114607, 48.0951514007166],
        [106.885779665799, 48.0951258482793],
        [106.885782802634, 48.0951087629591],
        [106.885789981023, 48.0950897333046],
        [106.885826220104, 48.0950240387285],
        [106.885875376148, 48.0949376840269],
        [106.885963999839, 48.0947046490004],
        [106.885928043145, 48.0945713838623],
        [106.885908485588, 48.0945393482124],
        [106.885783850344, 48.0944429444863],
        [106.88573050346, 48.0943913953467],
        [106.885680721488, 48.0943432915097],
        [106.885641906749, 48.0942281045435],
        [106.885640660288, 48.0941704894765],
        [106.885655377694, 48.0941067104564],
        [106.885679228614, 48.0940294757797],
        [106.885712410899, 48.0939664458948],
        [106.885731727437, 48.0939118723351],
        [106.885736760044, 48.0938746673821],
        [106.885781950077, 48.0938282362841],
        [106.885852752802, 48.0937828124269],
        [106.885932858115, 48.0937586521401],
        [106.886043148273, 48.0937439913922],
        [106.88613458954, 48.0937109691859],
        [106.886261934441, 48.0936559216835],
        [106.88633266522, 48.0935988381159],
        [106.886365201793, 48.0935536849546],
        [106.886464593067, 48.0935032698601],
        [106.886570005302, 48.0934717935884],
        [106.886713082942, 48.0934504059115],
        [106.886807583703, 48.0934119688873],
        [106.886832978759, 48.0933261672688],
        [106.886770726788, 48.0932395733476],
        [106.886654234905, 48.0931429690728],
        [106.886564248741, 48.0930135656236],
        [106.886485105703, 48.0928892199616],
        [106.886435348013, 48.0927622491785],
        [106.886440939098, 48.0926529311879],
        [106.886482488676, 48.0925944230942],
        [106.886558501174, 48.0925443290576],
        [106.886660558938, 48.0925101143504],
        [106.886745573649, 48.0925037210699],
        [106.886817219039, 48.0925227057583],
        [106.886957873007, 48.0925840988771],
        [106.887061933561, 48.0925910767169],
        [106.887182329401, 48.0925717251051],
        [106.887382302651, 48.092516276505],
        [106.887837535874, 48.0923930145261],
        [106.888112059324, 48.0923305907842],
        [106.888636552935, 48.0920511669279],
        [106.888775696941, 48.0919533242865],
        [106.888911788648, 48.0918902791132],
        [106.889023009604, 48.0918565995025],
        [106.889135182942, 48.091848963359],
        [106.889439031486, 48.0918787138316],
        [106.889568811751, 48.0918794728594],
        [106.889641762957, 48.0918637967768],
        [106.889722936664, 48.0918364007294],
        [106.88979482667, 48.0917917844633],
        [106.889814636037, 48.0917422336172],
        [106.889789099787, 48.0916355164659],
        [106.889755555075, 48.0915463046183],
        [106.889730654646, 48.0914569515771],
        [106.889683718129, 48.0913563776948],
        [106.889673165484, 48.0913044301554],
        [106.889679688267, 48.0912464112929],
        [106.889812136821, 48.0910883914162],
        [106.889982005265, 48.0908480278143],
        [106.890014100271, 48.0907654583593],
        [106.89012311519, 48.0904468141692],
        [106.890157471091, 48.0903268688899],
        [106.890158603337, 48.0902757415323],
        [106.890159810227, 48.0902117682585],
        [106.890163301395, 48.0901495423676],
        [106.890171356623, 48.0899938400438],
        [106.890212786591, 48.0899128444023],
        [106.890283718819, 48.0898373130416],
        [106.890381753915, 48.0897744234509],
        [106.890459941873, 48.0897030559513],
        [106.890505041974, 48.0895381166908],
        [106.89047720346, 48.0893601003884],
        [106.890370772293, 48.0891890889053],
        [106.890230222647, 48.0890562374555],
        [106.890218913672, 48.0889802744202],
        [106.890253249788, 48.088909271146],
        [106.890378596395, 48.0888405782301],
        [106.890546748034, 48.0887768918401],
        [106.890661363032, 48.0887255081757],
        [106.890767319356, 48.0886704597739],
        [106.890867316773, 48.0886078948385],
        [106.890975344237, 48.0885318715487],
        [106.891038843568, 48.0884813287504],
        [106.891074085301, 48.0884350595304],
        [106.891115640275, 48.0883613564915],
        [106.891128850416, 48.0883099764243],
        [106.891130240768, 48.0882776098239],
        [106.891092478235, 48.0881913639403],
        [106.891102261061, 48.0881043347473],
        [106.891164155102, 48.0880084265477],
        [106.891307756148, 48.087811392282],
        [106.891399871907, 48.0877287985452],
        [106.891510015475, 48.0876661778519],
        [106.891798221211, 48.0876237892065],
        [106.891914071877, 48.0875987170072],
        [106.891980781788, 48.0875310196409],
        [106.892053839113, 48.0871725498733],
        [106.892036576627, 48.086967463078],
        [106.891928179542, 48.0867997350198],
        [106.891833338838, 48.0867360989918],
        [106.891449865219, 48.0866348389267],
        [106.891356816864, 48.0866200711594],
        [106.891207051864, 48.0866518756836],
        [106.891148781191, 48.0866560953026],
        [106.891085289055, 48.0866506211293],
        [106.891011106677, 48.0866192428838],
        [106.890985013747, 48.086581379627],
        [106.89096527183, 48.0864523772754],
        [106.891021828395, 48.0863019962402],
        [106.891108487966, 48.0861082930633],
        [106.891260666746, 48.0859192222943],
        [106.891332257278, 48.0858674429282],
        [106.891362505076, 48.0858591781586],
        [106.891408703249, 48.0858509871334],
        [106.891463037589, 48.0858467270449],
        [106.891518857609, 48.0858459248496],
        [106.891643596275, 48.0858478143252],
        [106.891707957157, 48.0858491273354],
        [106.89177905486, 48.0858532363378],
        [106.892051884887, 48.0858791008399],
        [106.892167810196, 48.0858863340871],
        [106.892393433011, 48.0858983184527],
        [106.89249013801, 48.085900573053],
        [106.892540509037, 48.0858994884706],
        [106.892586852901, 48.0858965323991],
        [106.892630026654, 48.0858916499797],
        [106.892670447583, 48.0858847890518],
        [106.892750895537, 48.0858659230739],
        [106.892827566339, 48.0858425254122],
        [106.892897346535, 48.0858155520461],
        [106.892958371831, 48.0857857368223],
        [106.893000518559, 48.0857596654762],
        [106.893043099659, 48.0857276657992],
        [106.89308684808, 48.0856894581021],
        [106.893143843514, 48.0856344807468],
        [106.893187668376, 48.0855870576966],
        [106.89323062899, 48.0855316504653],
        [106.893267786279, 48.0854769842754],
        [106.893354265087, 48.0853413503231],
        [106.893454185163, 48.0851890564298],
        [106.893530653617, 48.0850649418936],
        [106.893594652971, 48.0849511506751],
        [106.893647698582, 48.0848447599777],
        [106.893718315148, 48.0846914822262],
        [106.893736839384, 48.084640342278],
        [106.89374907466, 48.0845938455296],
        [106.893757191042, 48.0845472588489],
        [106.8937621544, 48.084501148809],
        [106.893763925165, 48.0844558805345],
        [106.893762494344, 48.0844117418085],
        [106.893758219866, 48.0843719629957],
        [106.893750777976, 48.0843300033271],
        [106.893725924312, 48.0842372004865],
        [106.893710695193, 48.0841945951045],
        [106.893690791397, 48.0841481882883],
        [106.893627587943, 48.084023258067],
        [106.89359218703, 48.0839650935143],
        [106.89351556659, 48.0838589465332],
        [106.893487055383, 48.0838162017563],
        [106.893474726577, 48.0837617478065],
        [106.893481735893, 48.0837188942116],
        [106.893502572286, 48.0836895448367],
        [106.893607073508, 48.0836068872481],
        [106.893704727291, 48.0835388850116],
        [106.893805793103, 48.0834187122039],
        [106.893876135375, 48.083303328286],
        [106.89394569254, 48.0831665405035],
        [106.893968949907, 48.0831035717725],
        [106.893977583399, 48.0830291843494],
        [106.893981979285, 48.0829167915767],
        [106.893973197405, 48.0828126042184],
        [106.893975082384, 48.082781002941],
        [106.893972957286, 48.0827511310599],
        [106.893961643815, 48.0827106210983],
        [106.893928564951, 48.0826373461367],
        [106.893896616536, 48.0825689221181],
        [106.893804022338, 48.0823969096897],
        [106.893765991807, 48.08231668117],
        [106.893719933029, 48.0822004330036],
        [106.893687754386, 48.0821024077999],
        [106.893665491669, 48.0820178994066],
        [106.893651928094, 48.0819480634524],
        [106.893637238568, 48.0818590017915],
        [106.893632676307, 48.0818106704261],
        [106.89363451632, 48.0817654929832],
        [106.893643770344, 48.0817258985314],
        [106.893657860022, 48.081692548972],
        [106.893677114507, 48.0816582236482],
        [106.893701144392, 48.0816236231317],
        [106.893729250005, 48.0815897618581],
        [106.893810675522, 48.0815528572786],
        [106.893920012399, 48.0815129795404],
        [106.894088694638, 48.0814645087801],
        [106.894215346161, 48.0814319605166],
        [106.894324541844, 48.0813882777469],
        [106.894484170608, 48.0813157231421],
        [106.894558757681, 48.0812193068256],
        [106.894601814522, 48.0811153191167],
        [106.894629325683, 48.0810134915794],
        [106.894649036124, 48.0808408037601],
        [106.894682442341, 48.0807185283375],
        [106.894751012949, 48.0806090178919],
        [106.894871387205, 48.080502326821],
        [106.895033999919, 48.0803854212502],
        [106.895207608644, 48.0802778515417],
        [106.895474540917, 48.0801972974673],
        [106.895609982415, 48.0801141542449],
        [106.895695212064, 48.0800175616612],
        [106.895689916856, 48.079902472721],
        [106.895532936596, 48.0797257289593],
        [106.895466277946, 48.079614892913],
        [106.895461663525, 48.0794893223744],
        [106.895475552655, 48.0794034254278],
        [106.895631331421, 48.0793132827818],
        [106.895816970377, 48.0792626266689],
        [106.895999000354, 48.0791910873988],
        [106.896221538493, 48.0790429681585],
        [106.896396503396, 48.0788758831156],
        [106.896512461981, 48.0785527144363],
        [106.896599233068, 48.0783049862861],
        [106.896648138201, 48.0781863854933],
        [106.896729683328, 48.0780862828557],
        [106.896808869534, 48.0779582580672],
        [106.896883010543, 48.0778499491159],
        [106.896923368519, 48.0777243030342],
        [106.89696934456, 48.0776497915047],
        [106.896980761453, 48.0775773088458],
        [106.896971816796, 48.0774419590792],
        [106.896913449896, 48.077357998373],
        [106.896827314629, 48.0773332445336],
        [106.896621528161, 48.0773254483108],
        [106.896435542067, 48.0773016378603],
        [106.896391557125, 48.0772642899151],
        [106.896325054957, 48.0771939980046],
        [106.89628333271, 48.0770733233752],
        [106.89625688185, 48.0769333600866],
        [106.896203588025, 48.0767688057359],
        [106.896145364117, 48.0766044276523],
        [106.89609785833, 48.0764503764838],
        [106.896002380006, 48.0763854787069],
        [106.895835237406, 48.0763787185031],
        [106.895726690135, 48.0763900823365],
        [106.895667657736, 48.0763600674632],
        [106.895651452852, 48.0763056027214],
        [106.895678269736, 48.0762623264453],
        [106.895740268998, 48.076219823586],
        [106.895761617105, 48.0761530516221],
        [106.895717062892, 48.0760617938168],
        [106.895672577028, 48.0760026031377],
        [106.895624001047, 48.0759312815035],
        [106.895567509233, 48.0758572313262],
        [106.895496413329, 48.0758292363303],
        [106.895420437703, 48.0758168247867],
        [106.89535682146, 48.0758250131139],
        [106.895307866865, 48.0758709217057],
        [106.895262549127, 48.0759700332904],
        [106.895231974876, 48.0760785445892],
        [106.895172822868, 48.0761326460049],
        [106.895086411509, 48.076192811549],
        [106.894997655617, 48.0761974070847],
        [106.894942075716, 48.0761836204778],
        [106.894874289317, 48.0761256726617],
        [106.894803683543, 48.0760753286136],
        [106.894728773614, 48.0759944687697],
        [106.89467669927, 48.0759183321654],
        [106.894643363201, 48.0758808070536],
        [106.894621855914, 48.0758552375292],
        [106.894581200262, 48.0758318596527],
        [106.894537741424, 48.0758087794517],
        [106.894512319388, 48.0757741096875],
        [106.894530909274, 48.0757313721052],
        [106.894644489152, 48.075621404804],
        [106.89474486968, 48.0755507387756],
        [106.894894931456, 48.0754792534648],
        [106.894982593772, 48.0754181859006],
        [106.895002908557, 48.0753572325503],
        [106.895009678654, 48.0752798728679],
        [106.894962957974, 48.0752044692109],
        [106.894968308041, 48.0751567880554],
        [106.89497694513, 48.0751019132228],
        [106.894999427282, 48.0750372915378],
        [106.895029443954, 48.0749844437771],
        [106.895088760538, 48.0749309745848],
        [106.895159586646, 48.0749331905144],
        [106.895206283943, 48.074966261284],
        [106.895224916097, 48.0750607152798],
        [106.895273662949, 48.0751339326849],
        [106.895294918426, 48.075178010257],
        [106.895373705332, 48.0752121134483],
        [106.895475285556, 48.0752731792139],
        [106.895547988549, 48.07536484711],
        [106.895621667306, 48.0754061340859],
        [106.895698483798, 48.0754112620202],
        [106.895783304256, 48.0754003442506],
        [106.895883177567, 48.07539805008],
        [106.896044948516, 48.0753698491393],
        [106.896133765561, 48.0753556290591],
        [106.896205524266, 48.0753423496698],
        [106.896273167673, 48.0752994511088],
        [106.896317001528, 48.0752591201124],
        [106.896361911873, 48.0751976280681],
        [106.896418331741, 48.0750870950934],
        [106.896443867091, 48.0749526050787],
        [106.896383340019, 48.0748182319759],
        [106.896277403479, 48.0746738934855],
        [106.896207007248, 48.0745779780913],
        [106.89618172101, 48.0744537997031],
        [106.896152370735, 48.07436321549],
        [106.896123485411, 48.0742732446146],
        [106.896094697213, 48.0741835750121],
        [106.896079052606, 48.0741348461463],
        [106.896063378322, 48.0740706966054],
        [106.896051540546, 48.0740222510261],
        [106.8960319695, 48.073984311327],
        [106.895974101723, 48.0739643949409],
        [106.895919408554, 48.0739703700366],
        [106.89589909197, 48.0739725895634],
        [106.895852282257, 48.0739924654799],
        [106.895809594138, 48.0740105904165],
        [106.895706378047, 48.0740992563756],
        [106.895646066813, 48.0741541671811],
        [106.895564740221, 48.0742024688689],
        [106.895494982508, 48.0742123164453],
        [106.895303140028, 48.0741731257892],
        [106.895135235703, 48.0741267324628],
        [106.895002756572, 48.0740967922332],
        [106.894823495608, 48.0741016476729],
        [106.894635479744, 48.0741121148823],
        [106.89449600029, 48.07412418918],
        [106.894429476539, 48.0741014893923],
        [106.894367059992, 48.0740424632891],
        [106.894359890597, 48.0739886658443],
        [106.894397311387, 48.073819298322],
        [106.894404711009, 48.0736946711722],
        [106.894428711216, 48.0735996811804],
        [106.894506996301, 48.0735392557321],
        [106.894647209601, 48.073538682864],
        [106.894761679808, 48.0735618224202],
        [106.894877896498, 48.0735442523654],
        [106.894941950711, 48.0735205849071],
        [106.895008539213, 48.0734614994487],
        [106.895050785765, 48.0733726949939],
        [106.895073110536, 48.0732804830079],
        [106.895058472271, 48.0731577714141],
        [106.895016392992, 48.073108028113],
        [106.894925671183, 48.0730773486408],
        [106.894853382777, 48.0730773612313],
        [106.894819198647, 48.0730773666272],
        [106.894735510436, 48.0730613541982],
        [106.894659157095, 48.0730330462381],
        [106.894590702499, 48.0729367783097],
        [106.894606506285, 48.072862738025],
        [106.894696388128, 48.0728191343956],
        [106.894781467591, 48.0728004986441],
        [106.894892586024, 48.0727715260851],
        [106.89507489569, 48.0727030346174],
        [106.895104379963, 48.0726744955316],
        [106.895127531211, 48.0726474610116],
        [106.895140634333, 48.0726165135413],
        [106.89516779206, 48.0725849050694],
        [106.895190633041, 48.072558322009],
        [106.895208869494, 48.0725370980087],
        [106.895228431547, 48.0725224876227],
        [106.895245545645, 48.0725152211006],
        [106.895273694425, 48.0725032682113],
        [106.895311117914, 48.072510309903],
        [106.895348541402, 48.0725173506953],
        [106.895381917042, 48.0725386286548],
        [106.895427744695, 48.0725678449302],
        [106.895442218384, 48.0725770728737],
        [106.895456641711, 48.0726088018547],
        [106.895473317839, 48.0726454869997],
        [106.895482408187, 48.0727372385328],
        [106.895509376157, 48.0728241265323],
        [106.895545452461, 48.0728970282753],
        [106.895616975543, 48.0729762621448],
        [106.895676230973, 48.0730018424611],
        [106.895740114315, 48.073029421071],
        [106.895762217852, 48.0730389628779],
        [106.895865987925, 48.0730526190832],
        [106.89597547229, 48.073055073333],
        [106.89611691946, 48.0730445962312],
        [106.896304362456, 48.0730108680572],
        [106.896437614105, 48.0729767019133],
        [106.89653835706, 48.0729575670382],
        [106.896648008699, 48.0729420231559],
        [106.896724535609, 48.072931174634],
        [106.896780129, 48.0728881339802],
        [106.896852724074, 48.072840984324],
        [106.896912624318, 48.0727595812897],
        [106.89691351105, 48.0727059565147],
        [106.896914397781, 48.0726523326391],
        [106.896910599045, 48.0725490050326],
        [106.896887556616, 48.072493867598],
        [106.896854177378, 48.0724139970084],
        [106.896836007476, 48.0723705183848],
        [106.896797756611, 48.0722789889842],
        [106.896781474386, 48.0721471483723],
        [106.89676519216, 48.0720153077603],
        [106.896724041881, 48.0719068531188],
        [106.896682892502, 48.0717983984774],
        [106.896627809926, 48.0716997473455],
        [106.896588417821, 48.0716391294423],
        [106.896549025717, 48.0715785106398],
        [106.896432073382, 48.0715076863307],
        [106.896278143622, 48.0714567604212],
        [106.896200560008, 48.0714310928707],
        [106.896121982643, 48.0713971092892],
        [106.896007633845, 48.0713882338799],
        [106.895847233463, 48.0713730263441],
        [106.895581212203, 48.0713833685477],
        [106.89524397453, 48.0713889335525],
        [106.895007989727, 48.0712499891957],
        [106.894897124902, 48.071132787748],
        [106.894899228417, 48.0709482549581],
        [106.894965200883, 48.0708102809697],
        [106.895099110835, 48.0705878642386],
        [106.895207051964, 48.0703837307246],
        [106.895339108413, 48.0702510357568],
        [106.895530955389, 48.0700346273962],
        [106.895655651787, 48.0699254847734],
        [106.895767477987, 48.0698284524212],
        [106.895829640026, 48.0697084432901],
        [106.895844651509, 48.0696338310365],
        [106.895774079011, 48.0695249357273],
        [106.895721358054, 48.069418721297],
        [106.895690158774, 48.0692943036892],
        [106.895712511423, 48.0691779260205],
        [106.895789836032, 48.0691082339579],
        [106.896009856969, 48.0690570094734],
        [106.896201986333, 48.0690116980315],
        [106.896379802986, 48.0689230941255],
        [106.896575760763, 48.0687485222266],
        [106.896680448144, 48.0686177212309],
        [106.89675268259, 48.0684656260878],
        [106.896811303099, 48.0683694328031],
        [106.896848240054, 48.0681664702065],
        [106.896831057607, 48.0679405955821],
        [106.896740696426, 48.0676564125135],
        [106.896141377423, 48.0658451329466],
        [106.896020337669, 48.0656923902916],
        [106.895729605737, 48.0655126913577],
        [106.895399969133, 48.0654824219762],
        [106.895122920387, 48.0654334296091],
        [106.89497941287, 48.0653941364303],
        [106.894870853907, 48.0653393875028],
        [106.894810009375, 48.0652540931019],
        [106.894797204827, 48.0651471763012],
        [106.894741232822, 48.0650737052873],
        [106.894626054849, 48.0649595498434],
        [106.894542372033, 48.0648567780179],
        [106.894462907038, 48.0647479852314],
        [106.894435701646, 48.0646115481845],
        [106.894449409113, 48.0645012184565],
        [106.894516139708, 48.0643840628742],
        [106.89459054242, 48.0642340460644],
        [106.894722621352, 48.0640830786712],
        [106.894869539098, 48.0639735277562],
        [106.894970490696, 48.0639421045445],
        [106.895144396197, 48.0639630416611],
        [106.895290916443, 48.0639635992408],
        [106.895445436158, 48.0639402195656],
        [106.895510458041, 48.0638974855805],
        [106.895515944805, 48.0638051458908],
        [106.89547728385, 48.0637194863652],
        [106.895381492562, 48.0636496486125],
        [106.895316976098, 48.0635852454628],
        [106.895349957834, 48.0635162584686],
        [106.89551105609, 48.0634302787844],
        [106.895629425757, 48.0633896402198],
        [106.895865223501, 48.0634036030939],
        [106.896085460276, 48.0634773376091],
        [106.896301369513, 48.0635541190274],
        [106.896400506278, 48.0635941433551],
        [106.896502440835, 48.0635894848669],
        [106.896580879704, 48.063549504606],
        [106.896662116364, 48.0634648415292],
        [106.896730151875, 48.0633833719451],
        [106.896945361439, 48.06332030249],
        [106.897176724626, 48.0633560127698],
        [106.897268039988, 48.0633104513163],
        [106.897347993315, 48.0632677847805],
        [106.897614873428, 48.0631282594617],
        [106.897712804203, 48.0630737209755],
        [106.897764710373, 48.0630418570961],
        [106.897810859084, 48.0630107999086],
        [106.897852144261, 48.0629799459678],
        [106.897888990385, 48.0629489742158],
        [106.897960754485, 48.0628840278756],
        [106.898004912996, 48.062839379234],
        [106.898039123207, 48.0627972271104],
        [106.898062836531, 48.0627574842705],
        [106.898072324378, 48.0627341396689],
        [106.898079894871, 48.06270732908],
        [106.898223197343, 48.0625772682264],
        [106.898302569708, 48.0624420461635],
        [106.898369678018, 48.06221477759],
        [106.898406775952, 48.061895756584],
        [106.898370907392, 48.0617654151418],
        [106.898289300211, 48.0617191513178],
        [106.898233556633, 48.0616961214789],
        [106.897849820413, 48.0615984551047],
        [106.897562714548, 48.0615169009843],
        [106.897167056914, 48.0613805997349],
        [106.896952530835, 48.0612204745453],
        [106.896896670345, 48.0611499784887],
        [106.896915136125, 48.0610484971904],
        [106.897170673987, 48.0606336192462],
        [106.89727557271, 48.0604682186334],
        [106.897511311098, 48.0603601722842],
        [106.898036085297, 48.0602719442949],
        [106.89831666838, 48.0600492874447],
        [106.898365529446, 48.0599294482855],
        [106.898380102959, 48.0598429101223],
        [106.898375399505, 48.0597150292253],
        [106.898392550476, 48.0595778601302],
        [106.898402139947, 48.059476524522],
        [106.898258052367, 48.0593003590244],
        [106.898205268458, 48.0590720966999],
        [106.898137036895, 48.058906580974],
        [106.898142299727, 48.0588082931682],
        [106.898151234492, 48.0586891141114],
        [106.898209404441, 48.0585810245947],
        [106.898356955309, 48.0584893126317],
        [106.898481996147, 48.0583890454181],
        [106.898564753561, 48.0583460164556],
        [106.898642308396, 48.0582822428313],
        [106.898670626248, 48.0582073805662],
        [106.898636620184, 48.0581275963116],
        [106.898624357028, 48.0580355498008],
        [106.89857561917, 48.0579173240253],
        [106.898500374693, 48.0578025129756],
        [106.898359353801, 48.0577096184042],
        [106.898276987593, 48.0576425370735],
        [106.898291342571, 48.0575500507942],
        [106.898349510721, 48.0574419612776],
        [106.898487857928, 48.0573414737301],
        [106.898807708109, 48.0571070510496],
        [106.898807744082, 48.0569758381645],
        [106.89877208956, 48.0569053295174],
        [106.898747684658, 48.0568416179464],
        [106.898729805236, 48.0567814901737],
        [106.89871832539, 48.0567245163234],
        [106.898713213644, 48.0566705291217],
        [106.898713844968, 48.0566030278076],
        [106.89872095231, 48.056541325322],
        [106.898734580636, 48.0564850340571],
        [106.898754756927, 48.0564340694768],
        [106.898775289348, 48.0563982944458],
        [106.898803710623, 48.0563596128059],
        [106.898836575448, 48.0563212117546],
        [106.898908494232, 48.0562429086833],
        [106.898951019574, 48.0561998374526],
        [106.899068560066, 48.0560928774844],
        [106.899098564147, 48.0560606979429],
        [106.899121741475, 48.0560305562652],
        [106.899161089513, 48.0559657016559],
        [106.899191522571, 48.0559000421533],
        [106.899212215971, 48.0558353683077],
        [106.8992227902, 48.0557729031969],
        [106.89922420933, 48.0557354509303],
        [106.89922200689, 48.0556953249793],
        [106.899216172988, 48.055652135038],
        [106.899206557437, 48.0556047623499],
        [106.899190212259, 48.055551059334],
        [106.899150651082, 48.055450748953],
        [106.899094651197, 48.0553113468412],
        [106.899072928973, 48.0552499429306],
        [106.89903507381, 48.0551294724473],
        [106.899027675087, 48.0550904328773],
        [106.899025579667, 48.0550553719079],
        [106.899028797441, 48.0550005888062],
        [106.899036933608, 48.0549542098689],
        [106.899050397358, 48.0549139571135],
        [106.89906935057, 48.0548795022872],
        [106.899094030665, 48.0548512347967],
        [106.899129860555, 48.0548224591892],
        [106.899169015238, 48.0547971153946],
        [106.899260157031, 48.0547435095054],
        [106.899294613656, 48.0547208402946],
        [106.899394156915, 48.0546481669793],
        [106.899657318331, 48.0544506551736],
        [106.899738420991, 48.0543926111301],
        [106.899813196022, 48.0543417634617],
        [106.899872947878, 48.0543051169876],
        [106.900000908815, 48.0542340039962],
        [106.900053721502, 48.0542028460845],
        [106.900105561123, 48.0541680171403],
        [106.900147177251, 48.0541341477727],
        [106.900190052429, 48.0540929291454],
        [106.900226733977, 48.054053095474],
        [106.900257389167, 48.0540144641962],
        [106.90028205937, 48.0539769786547],
        [106.90029832181, 48.0539448908441],
        [106.900312124605, 48.0539079637816],
        [106.900345163898, 48.0537805802097],
        [106.900369060684, 48.0536794892171],
        [106.900408261232, 48.0534540723476],
        [106.900429967269, 48.0533547853951],
        [106.900463733215, 48.0532169103322],
        [106.900481984056, 48.0531508794096],
        [106.900503908629, 48.0530865554003],
        [106.90052852757, 48.0530298081791],
        [106.900574281478, 48.0529432933983],
        [106.900622268403, 48.0528666073081],
        [106.900673607101, 48.0527979728482],
        [106.900728738241, 48.0527368306403],
        [106.90076946314, 48.0526992542672],
        [106.900819521204, 48.0526593072813],
        [106.901012252214, 48.0525233118014],
        [106.901243958042, 48.0523541960893],
        [106.901430748131, 48.0522218239781],
        [106.901603435051, 48.0521043689216],
        [106.901766581063, 48.0519988586604],
        [106.901847440007, 48.051951035412],
        [106.902014799344, 48.0518597910965],
        [106.902083542621, 48.0518205168035],
        [106.902152097941, 48.0517771883666],
        [106.90220900704, 48.0517355497558],
        [106.902287573613, 48.0516714829527],
        [106.90234306538, 48.0516215678811],
        [106.902387827336, 48.0515746970147],
        [106.902422469222, 48.0515299233673],
        [106.90244561867, 48.0514938371709],
        [106.902463955847, 48.051460866226],
        [106.902478053619, 48.0514299745138],
        [106.902488044188, 48.051400846372],
        [106.902495767566, 48.0513599083332],
        [106.902497135435, 48.0513143199],
        [106.902492319565, 48.0512632258172],
        [106.902480601399, 48.0511988784256],
        [106.902470960666, 48.0511631258776],
        [106.902456047209, 48.0511236591296],
        [106.902381550968, 48.0509647453268],
        [106.902314119801, 48.0507940198282],
        [106.902270228388, 48.0506701876791],
        [106.902215766345, 48.0504877593027],
        [106.902194527056, 48.0504029919046],
        [106.902177004665, 48.0503214404822],
        [106.902149121185, 48.0501556774426],
        [106.902192887592, 48.0500758032558],
        [106.902453208949, 48.0499137751007],
        [106.902565025256, 48.0498166977824],
        [106.902741399396, 48.0496649866499],
        [106.902856334552, 48.0495321477904],
        [106.90288135549, 48.0493680655838],
        [106.902882393308, 48.0492757987392],
        [106.902818047715, 48.0490953416767],
        [106.902710882701, 48.0489572552731],
        [106.902623322908, 48.0488694319787],
        [106.902511065933, 48.0487135749716],
        [106.90248981855, 48.0486187018917],
        [106.902454203599, 48.0485180048021],
        [106.902448777089, 48.048427266805],
        [106.902435494103, 48.0483488054531],
        [106.902440310872, 48.0482386214153],
        [106.902405866837, 48.0481469427273],
        [106.902395682015, 48.0481114024194],
        [106.902279695552, 48.0479453237178],
        [106.902264724537, 48.0478894965031],
        [106.90225473307, 48.0478386542306],
        [106.902239051591, 48.0477106816027],
        [106.902236008285, 48.0476551619562],
        [106.902236010983, 48.0476031910345],
        [106.902240202723, 48.0475307758247],
        [106.902349511721, 48.0474604695251],
        [106.902511424762, 48.0473982724124],
        [106.902666549722, 48.0473927262933],
        [106.90282255062, 48.0474109726383],
        [106.902978441802, 48.0474262449253],
        [106.903115058713, 48.0474001744785],
        [106.903128744596, 48.0472898438513],
        [106.903144234519, 48.0471080638861],
        [106.903156985107, 48.0468519351687],
        [106.903192189068, 48.04672339327],
        [106.903452005006, 48.0464161686713],
        [106.903607226193, 48.0463300145186],
        [106.903715034222, 48.0462756064342],
        [106.903940170503, 48.0461702868293],
        [106.904034035442, 48.0461243296741],
        [106.904128823986, 48.0460731780348],
        [106.904208744938, 48.0460236424772],
        [106.904315431512, 48.045951580701],
        [106.904382635151, 48.0459022861616],
        [106.904438393117, 48.0458552372295],
        [106.904482167618, 48.0458102810197],
        [106.904505845868, 48.0457806510562],
        [106.904527754252, 48.0457487098352],
        [106.904547988099, 48.0457143206594],
        [106.904566685904, 48.0456772425108],
        [106.904599830418, 48.0455946694585],
        [106.904631137617, 48.0454912006584],
        [106.90464250235, 48.045438457219],
        [106.904649687033, 48.0453788969186],
        [106.904658882601, 48.0451539207169],
        [106.904663152582, 48.0450591096902],
        [106.904662283837, 48.0448268984426],
        [106.904666221069, 48.0447214772145],
        [106.904671877805, 48.0446640599984],
        [106.904680216319, 48.0446108363211],
        [106.904691405684, 48.044560724298],
        [106.904788287849, 48.0445156817533],
        [106.905160107153, 48.0443696525375],
        [106.905644625, 48.0441926875425],
        [106.905775015005, 48.044076751441],
        [106.905882047818, 48.0439708229952],
        [106.906010158042, 48.0438347861465],
        [106.90604388172, 48.0437866139611],
        [106.906119978754, 48.0436841739855],
        [106.90615337238, 48.0436270796261],
        [106.906173790588, 48.0435791286739],
        [106.906157961621, 48.0435109483716],
        [106.906181936647, 48.043439131211],
        [106.906170651954, 48.0433738512223],
        [106.906158928392, 48.0432966750016],
        [106.906107071684, 48.0432142134652],
        [106.90603747495, 48.0431320469065],
        [106.906016441606, 48.0430513651285],
        [106.906032147366, 48.0429573023377],
        [106.906046204669, 48.0429334532163],
        [106.906083116443, 48.0428586404139],
        [106.906099069517, 48.0428368777198],
        [106.906117471444, 48.0428194740396],
        [106.906143541891, 48.042801488498],
        [106.906174220464, 48.0427845021031],
        [106.906208088932, 48.0427693053592],
        [106.906243236236, 48.0427567589173],
        [106.906301420574, 48.0427425397365],
        [106.906364904617, 48.0427341787394],
        [106.906427330157, 48.0427324934099],
        [106.906456502366, 48.0427342129137],
        [106.906483620523, 48.042737612351],
        [106.906513929474, 48.0427447664579],
        [106.906546271793, 48.042756811078],
        [106.906642892256, 48.0428058349214],
        [106.906675025032, 48.0428203238989],
        [106.906745277373, 48.0428468458053],
        [106.906957530865, 48.0429217314528],
        [106.907019392531, 48.0429473270576],
        [106.907185441555, 48.0430218790565],
        [106.907237804581, 48.0430420688365],
        [106.907286522655, 48.0430577332278],
        [106.907368471578, 48.0430806803292],
        [106.907427030933, 48.0430947331355],
        [106.907480541494, 48.043104301922],
        [106.907529519472, 48.0431092733743],
        [106.907587922345, 48.0431109793882],
        [106.90764346987, 48.0431092374014],
        [106.907694427256, 48.0431041049705],
        [106.907739972522, 48.043095672927],
        [106.907808810228, 48.0430770461688],
        [106.907861984443, 48.0430571001052],
        [106.907883220135, 48.043046437743],
        [106.907900836954, 48.0430353275184],
        [106.907914840298, 48.0430237667335],
        [106.907967376893, 48.0429954138074],
        [106.908032332226, 48.042956085555],
        [106.90820298488, 48.0428907588015],
        [106.908337717712, 48.0428141257713],
        [106.908468895523, 48.0427613580503],
        [106.908528346106, 48.0426889509344],
        [106.908572623328, 48.0425662078642],
        [106.908606931565, 48.0424138726022],
        [106.908665282277, 48.0423117258056],
        [106.90871575223, 48.0422364921205],
        [106.908641608523, 48.0421514261474],
        [106.908519780963, 48.0420969110436],
        [106.908159903757, 48.042085035496],
        [106.907983171686, 48.0421058269224],
        [106.907924860544, 48.0420889403524],
        [106.907856531853, 48.042021081108],
        [106.90784596482, 48.0419716453752],
        [106.907774707936, 48.0418682503196],
        [106.907739600202, 48.0417587299814],
        [106.907762803611, 48.0416660944148],
        [106.907812945311, 48.041581939455],
        [106.907876060632, 48.0414886419873],
        [106.907943610509, 48.0413952698759],
        [106.908099195921, 48.0412825812262],
        [106.908230699287, 48.0412387356791],
        [106.908397350857, 48.0411853780029],
        [106.908546702169, 48.0411442106368],
        [106.908683189578, 48.0411151607361],
        [106.908877657178, 48.0410940743321],
        [106.909028106562, 48.0410826457476],
        [106.909156383161, 48.0410715867844],
        [106.909267910786, 48.0410875875222],
        [106.909363017689, 48.0411395701351],
        [106.909461085161, 48.0412570620638],
        [106.909576356664, 48.0413515223549],
        [106.909685253771, 48.0414175325931],
        [106.90982408931, 48.0414295016702],
        [106.909977300512, 48.041398397718],
        [106.910071337223, 48.0413504305779],
        [106.910168582714, 48.0412452971328],
        [106.91025624413, 48.0411688790406],
        [106.910316564358, 48.0410960375522],
        [106.91035814811, 48.0410458203084],
        [106.91044673313, 48.0409943736914],
        [106.910554615803, 48.0408890630799],
        [106.910673533157, 48.0407942772342],
        [106.910841338557, 48.0406775425346],
        [106.911130504769, 48.0405775064468],
        [106.911376310169, 48.0405113001564],
        [106.911522745878, 48.0404410424202],
        [106.911545118313, 48.0403264454092],
        [106.911379330991, 48.0401614369009],
        [106.911228804266, 48.040121107703],
        [106.910957083103, 48.0400878984378],
        [106.910883654357, 48.0400221651908],
        [106.910822468982, 48.0398511833854],
        [106.910838220607, 48.0397951879976],
        [106.910855683643, 48.0397447279369],
        [106.910886572657, 48.0396705023918],
        [106.910918400564, 48.0396072728574],
        [106.910943232644, 48.0395654822612],
        [106.910971709677, 48.0395226943169],
        [106.911040042864, 48.0394334698788],
        [106.911102228285, 48.0393657248484],
        [106.911228883406, 48.0392433927684],
        [106.911456067444, 48.0390198150125],
        [106.911614464136, 48.0388732102305],
        [106.911743161618, 48.0387573541686],
        [106.911807122301, 48.0387021321977],
        [106.911873054298, 48.038649739494],
        [106.911936017633, 48.0386051394157],
        [106.912005622462, 48.0385619377832],
        [106.912087135213, 48.0385168934399],
        [106.912169209142, 48.0384295512828],
        [106.912317590085, 48.0382425813301],
        [106.912376479491, 48.0381553030249],
        [106.912452445224, 48.0380498853939],
        [106.912524197634, 48.0379504887241],
        [106.912574327643, 48.0378663319657],
        [106.912637760424, 48.037781953974],
        [106.912736998814, 48.0377059064025],
        [106.912800541312, 48.0376245015696],
        [106.912877717533, 48.0375517967781],
        [106.912950128246, 48.0374702444562],
        [106.913014221129, 48.0374037099133],
        [106.91306977585, 48.0373462441339],
        [106.913147391839, 48.0372854355745],
        [106.913185428665, 48.0372342128887],
        [106.913335447273, 48.0371020710038],
        [106.913347227493, 48.0370392029969],
        [106.91336744695, 48.0369717637359],
        [106.913380277578, 48.0369417119905],
        [106.913395127183, 48.0369135811969],
        [106.913425303935, 48.0368670673613],
        [106.913462671665, 48.0368186784393],
        [106.913507546037, 48.0367679818569],
        [106.913560990947, 48.0367137770192],
        [106.913639044906, 48.0366440363932],
        [106.91372909762, 48.0365745637652],
        [106.913781525397, 48.0365385450179],
        [106.913840488548, 48.0365014767618],
        [106.913907211049, 48.0364625568016],
        [106.913986985411, 48.0364186977648],
        [106.914091595451, 48.036366802386],
        [106.9142142333, 48.0363141506776],
        [106.914322078201, 48.0362722683506],
        [106.914568416, 48.0361817255063],
        [106.914676693475, 48.0361402721559],
        [106.915003721145, 48.0360142393657],
        [106.915065643065, 48.0358875761508],
        [106.91527778684, 48.0355061125171],
        [106.915357784234, 48.0351506590757],
        [106.915364053408, 48.0348410719579],
        [106.915291918787, 48.0346905092596],
        [106.915316207677, 48.0346276124744],
        [106.915468425128, 48.0345447282567],
        [106.915721500647, 48.0345494344089],
        [106.915900079026, 48.0345791884788],
        [106.916045743117, 48.03455890427],
        [106.916184105612, 48.0344613700962],
        [106.916285008646, 48.0343108973301],
        [106.916460497854, 48.0342573804738],
        [106.916659811002, 48.0342481021682],
        [106.916871985354, 48.0342267063974],
        [106.917042597538, 48.0341613670535],
        [106.916999159384, 48.0340668671922],
        [106.916935096178, 48.0340143719657],
        [106.916901299655, 48.033940541223],
        [106.916907519367, 48.0338690181407],
        [106.916957527968, 48.0337818855256],
        [106.917118297072, 48.0335708964797],
        [106.917198570558, 48.0334624274491],
        [106.917329293312, 48.0332787220354],
        [106.917423309338, 48.0331819271043],
        [106.917513222657, 48.0330941271923],
        [106.917661329307, 48.0330202352957],
        [106.91775854602, 48.0330096844494],
        [106.917935795201, 48.0330037489239],
        [106.918065153684, 48.0330224197489],
        [106.918163695098, 48.0330475558001],
        [106.918248382457, 48.0330580445931],
        [106.918387405055, 48.0331022669561],
        [106.918607187672, 48.0331621555091],
        [106.91875006926, 48.033186550519],
        [106.918922443216, 48.0331687916065],
        [106.919065671943, 48.033083076323],
        [106.919104141343, 48.0330437480706],
        [106.919168772921, 48.032992079321],
        [106.919205364536, 48.0329021938812],
        [106.919193514169, 48.0328220454011],
        [106.919074475407, 48.032722857374],
        [106.918967744766, 48.0325966815917],
        [106.918822560913, 48.0323908015943],
        [106.918739657809, 48.0323088643627],
        [106.918528723622, 48.0322439450021],
        [106.918393718296, 48.0321926359814],
        [106.91831324516, 48.032176125328],
        [106.918161057387, 48.0321399824743],
        [106.917990691617, 48.0320922392655],
        [106.917855135007, 48.0320260590554],
        [106.91775959463, 48.0319621874051],
        [106.917746863827, 48.0318582473603],
        [106.917787890899, 48.031768288176],
        [106.917908396455, 48.0316680740224],
        [106.918141073552, 48.0316016968609],
        [106.918423735867, 48.0315672177529],
        [106.918567965539, 48.0315518672249],
        [106.918768472987, 48.0315317008274],
        [106.919006796926, 48.0314979609621],
        [106.919194469249, 48.031414477796],
        [106.919279279815, 48.0313089081796],
        [106.919285843067, 48.031127274804],
        [106.91930681166, 48.0309751589764],
        [106.919253621258, 48.0308570159386],
        [106.919170388103, 48.0307661565329],
        [106.918935634472, 48.0306569995209],
        [106.918405753023, 48.030598934793],
        [106.91811118908, 48.0305576909847],
        [106.917899839406, 48.0303618429248],
        [106.917779263702, 48.0302210180856],
        [106.917747584184, 48.030084660179],
        [106.917834400237, 48.02991359024],
        [106.917998135306, 48.0297828962637],
        [106.918190458023, 48.0297052892677],
        [106.918286785307, 48.0296709468568],
        [106.918396744514, 48.0296453035879],
        [106.918485146972, 48.0295905699489],
        [106.918651580006, 48.0295785550064],
        [106.918866732014, 48.0295184200391],
        [106.919064921909, 48.0294793993548],
        [106.919167464407, 48.0293735329622],
        [106.919226664079, 48.0292951723344],
        [106.919312023231, 48.0292044721087],
        [106.919383197377, 48.029090202451],
        [106.919398060472, 48.0290125828645],
        [106.919372135716, 48.0289118390102],
        [106.919324596653, 48.0288263359667],
        [106.919195942339, 48.0287197393246],
        [106.919168109221, 48.0286742093473],
        [106.919095625663, 48.0286337596403],
        [106.918923614134, 48.0285414082594],
        [106.918824639246, 48.0285043768756],
        [106.918628125688, 48.0284689741639],
        [106.918484594788, 48.028426734806],
        [106.918295734461, 48.0283584708668],
        [106.918199868529, 48.0282856770424],
        [106.918122731879, 48.0282393529638],
        [106.91800392604, 48.0281461112541],
        [106.917955617158, 48.0280397889052],
        [106.917939004881, 48.0279507928948],
        [106.917943567142, 48.027834660741],
        [106.917973074798, 48.0276734743514],
        [106.918008782379, 48.0275597982462],
        [106.918106669088, 48.0274480583812],
        [106.918271719864, 48.0273530522016],
        [106.918380459591, 48.0272946951941],
        [106.91838612442, 48.027208302721],
        [106.918338035872, 48.0271079293875],
        [106.91831987856, 48.0269772974644],
        [106.918306484956, 48.0268555130716],
        [106.918349622737, 48.0267030267233],
        [106.918419360665, 48.0265500961101],
        [106.918499841894, 48.0264475742962],
        [106.918554495494, 48.0263663151534],
        [106.918565035548, 48.0262917442686],
        [106.918455431573, 48.0262072772441],
        [106.918311432127, 48.0261496774657],
        [106.918249963465, 48.0261057824559],
        [106.918147447946, 48.0260368494211],
        [106.917940090363, 48.0259480620535],
        [106.917608469855, 48.0259774069318],
        [106.9168101084, 48.0261008388826],
        [106.91661574602, 48.0260430700317],
        [106.916569482196, 48.0260096512244],
        [106.916531746643, 48.0259777729559],
        [106.916471223168, 48.0259203782229],
        [106.916431785199, 48.0258778771624],
        [106.916402151638, 48.0258381280273],
        [106.916382354862, 48.0258006289959],
        [106.916372245583, 48.0257718201134],
        [106.916365051906, 48.0257418034415],
        [106.916360959091, 48.0257113398065],
        [106.916360075057, 48.0256812421956],
        [106.916364599547, 48.0256431343232],
        [106.916376436423, 48.0256016584898],
        [106.916395685513, 48.0255560583654],
        [106.916424784876, 48.0255005252291],
        [106.916412558593, 48.0254289913549],
        [106.916387524165, 48.0253520381661],
        [106.916348528662, 48.0252574636611],
        [106.916340125397, 48.0251504749145],
        [106.916380709102, 48.0250486203976],
        [106.91650552511, 48.0249453611396],
        [106.916701383962, 48.0248438906331],
        [106.916989658046, 48.0248420551168],
        [106.917108915344, 48.0248281605912],
        [106.917195386958, 48.0248021512983],
        [106.917253652234, 48.0247441881938],
        [106.91733602114, 48.0246563289265],
        [106.917384679859, 48.0246013102023],
        [106.917425956942, 48.0245494265148],
        [106.917458867633, 48.0245012453362],
        [106.917479637475, 48.0244649352086],
        [106.917499854235, 48.0244236077634],
        [106.91755792256, 48.0242840257872],
        [106.917600482976, 48.0241812467672],
        [106.917641631456, 48.024074971183],
        [106.917720346417, 48.0238501829397],
        [106.917732937825, 48.0238057276522],
        [106.917706605675, 48.0235725415396],
        [106.917654418916, 48.0233706644247],
        [106.917651478133, 48.0233457514054],
        [106.917628551716, 48.023151530219],
        [106.917585600995, 48.022949974162],
        [106.917468997596, 48.0227710648328],
        [106.917344142918, 48.0226565442642],
        [106.917325109666, 48.0225259788909],
        [106.917395232504, 48.0224082036757],
        [106.917484315749, 48.0223234272844],
        [106.917615906349, 48.0221653606429],
        [106.917688603047, 48.0220213656935],
        [106.917647152394, 48.0218602386591],
        [106.917635474697, 48.0217366897964],
        [106.917589581394, 48.0216470282878],
        [106.917453283742, 48.0216064697628],
        [106.917345346211, 48.0215654372951],
        [106.917334727016, 48.0214704266189],
        [106.917367177253, 48.0213889759206],
        [106.917485589189, 48.0213298859655],
        [106.91757581727, 48.0212760264675],
        [106.917700965128, 48.0212073056726],
        [106.917769041108, 48.0211300188354],
        [106.917821348377, 48.0210101607904],
        [106.917831821881, 48.0209100392669],
        [106.917798873419, 48.0207868456364],
        [106.917821762065, 48.0206389224484],
        [106.917959675798, 48.0205319130174],
        [106.918233354786, 48.0204511916692],
        [106.918358677111, 48.0203872264894],
        [106.918497648448, 48.0203087552449],
        [106.918701663251, 48.0202625121053],
        [106.918857815236, 48.0202646623843],
        [106.919037002456, 48.0203140216748],
        [106.919190874659, 48.0203587800337],
        [106.919391519703, 48.0203560919601],
        [106.919500464475, 48.0203036821692],
        [106.919586913605, 48.020242720725],
        [106.919691093769, 48.0201814634038],
        [106.919742741834, 48.0201389389609],
        [106.919829411298, 48.0200839256327],
        [106.919889814264, 48.0200382787436],
        [106.919980253686, 48.019965347323],
        [106.920012622984, 48.0198814837435],
        [106.920036900183, 48.0198185860589],
        [106.920091655406, 48.0197403000748],
        [106.920053761572, 48.0196754661499],
        [106.919975863196, 48.0196083245646],
        [106.919924671986, 48.0195437127722],
        [106.919903405718, 48.0194488432895],
        [106.919891889, 48.0193776160842],
        [106.919871506765, 48.0193065381662],
        [106.919820095221, 48.0192359782578],
        [106.91972989322, 48.0191958244278],
        [106.919574634262, 48.0191954440146],
        [106.919411504437, 48.0192219767129],
        [106.919249036514, 48.0192663537593],
        [106.919130013939, 48.0192861973002],
        [106.919006116139, 48.0192942192528],
        [106.918871917505, 48.0192637277389],
        [106.918811641344, 48.0191933162186],
        [106.918768103365, 48.0190958422993],
        [106.918772662928, 48.0189797092462],
        [106.918817008498, 48.0188599366368],
        [106.918870217786, 48.0187400156392],
        [106.918945260815, 48.018610801947],
        [106.919071397927, 48.0184241944211],
        [106.919202392277, 48.0183684409508],
        [106.919391453153, 48.0183236196394],
        [106.919649986658, 48.0183579836341],
        [106.919843480292, 48.0183130885782],
        [106.920001070293, 48.0182568890443],
        [106.920137379636, 48.018224852495],
        [106.920370752808, 48.0182983208109],
        [106.920554138962, 48.0184589235405],
        [106.920636138247, 48.0185170683081],
        [106.92070593643, 48.0185847845602],
        [106.920803464309, 48.0186035435188],
        [106.920932345252, 48.0186103154138],
        [106.921077741345, 48.0185840767938],
        [106.921195878087, 48.0185404389901],
        [106.921310355489, 48.0185176933369],
        [106.921418299315, 48.0184385161247],
        [106.921483574807, 48.0184046908239],
        [106.921565695501, 48.0183467762827],
        [106.921686716369, 48.0182614288219],
        [106.921866024997, 48.0181929607366],
        [106.922009696191, 48.0181464684847],
        [106.922038039224, 48.0180789572781],
        [106.922058127381, 48.0180108624114],
        [106.922067808583, 48.0179485339977],
        [106.922069181847, 48.0178794318903],
        [106.922062635682, 48.0178023842727],
        [106.922046474865, 48.0176974972418],
        [106.922024927109, 48.0175832212887],
        [106.922013088433, 48.0175430647607],
        [106.921998769428, 48.0175074327219],
        [106.921978335931, 48.0174664407237],
        [106.921957726168, 48.0174312682385],
        [106.921935884334, 48.0174001175214],
        [106.921912474981, 48.0173725461062],
        [106.921878364595, 48.0173393737132],
        [106.921840222548, 48.0173082193988],
        [106.921798975143, 48.0172798349964],
        [106.921755457848, 48.0172547951727],
        [106.921694602524, 48.0172265007025],
        [106.921638291474, 48.0171947303526],
        [106.921592161649, 48.017163650682],
        [106.921565529126, 48.0171421074224],
        [106.921543097336, 48.0171208870194],
        [106.921517646522, 48.0170874322392],
        [106.92147394037, 48.0170080508809],
        [106.921434306348, 48.0169500410116],
        [106.921415893629, 48.0169252044347],
        [106.921402349839, 48.0168969333469],
        [106.921390928449, 48.0168585673691],
        [106.921389814189, 48.016838863223],
        [106.921391807086, 48.0168149673369],
        [106.921396685908, 48.0167928215316],
        [106.921409542616, 48.0167543206554],
        [106.921427586614, 48.0167020520581],
        [106.921454873843, 48.0166295118425],
        [106.921480223933, 48.0165720910292],
        [106.921494442215, 48.0165431868187],
        [106.921506071348, 48.0165280728124],
        [106.921525485913, 48.0165126611304],
        [106.921540095399, 48.0165023584971],
        [106.921562257392, 48.0164936062949],
        [106.92158959948, 48.0164897958674],
        [106.921619438986, 48.0164859440711],
        [106.921654086267, 48.0164769823269],
        [106.921695911038, 48.0164595183921],
        [106.921769451299, 48.0164214078218],
        [106.921825948509, 48.0163953166906],
        [106.92188013536, 48.0163742941384],
        [106.921969030646, 48.0163459843797],
        [106.922040507863, 48.0163196423377],
        [106.922102186067, 48.0162984929811],
        [106.92213538544, 48.0162840138962],
        [106.922175849536, 48.0162637332847],
        [106.92223946398, 48.0162274654252],
        [106.922295648226, 48.0161929980085],
        [106.922349709172, 48.0161686227838],
        [106.922421312294, 48.016145632515],
        [106.922522816075, 48.0161204631889],
        [106.922720705596, 48.0160668599976],
        [106.922819319856, 48.0160390448661],
        [106.922873897912, 48.0160207094882],
        [106.922921981964, 48.0160008614507],
        [106.922972219892, 48.0159771544222],
        [106.923050564332, 48.0159339330046],
        [106.923128847618, 48.0158890361502],
        [106.923166017498, 48.0158712079899],
        [106.923195205894, 48.0158594268711],
        [106.923249578006, 48.0158434279319],
        [106.923313938887, 48.0158272635174],
        [106.923339516506, 48.0158167729258],
        [106.92335813517, 48.0158064082392],
        [106.923384729921, 48.0157824916687],
        [106.923428178867, 48.0157415329455],
        [106.923486049342, 48.0156852434792],
        [106.923541734464, 48.0156373716674],
        [106.923571190858, 48.0156172790143],
        [106.923614959963, 48.0155908830129],
        [106.923708035298, 48.0155407098359],
        [106.92377177115, 48.0155077910518],
        [106.923805773618, 48.0154940215319],
        [106.923830951038, 48.0154866839633],
        [106.923873211979, 48.0154809462887],
        [106.923918094445, 48.0154785190185],
        [106.923988196598, 48.0154823735128],
        [106.924171097119, 48.0154960719862],
        [106.92434638218, 48.01550654639],
        [106.924406434409, 48.015508891822],
        [106.924456247858, 48.0155047054778],
        [106.924500881211, 48.0154955746611],
        [106.924545266351, 48.0154797438951],
        [106.924624231323, 48.0154532750487],
        [106.924698312977, 48.0154260049063],
        [106.924779418336, 48.015393677876],
        [106.924877466922, 48.0153505598805],
        [106.925042224519, 48.0152719267581],
        [106.925137656977, 48.0152276171609],
        [106.925187049543, 48.0152024442374],
        [106.925245346296, 48.0151684408709],
        [106.925304280668, 48.0151300730944],
        [106.925354135485, 48.0150947477245],
        [106.925391799992, 48.015064902823],
        [106.925435650035, 48.0150239773747],
        [106.92548087784, 48.0149745623262],
        [106.925523827663, 48.0149201983086],
        [106.925544926657, 48.0148829654765],
        [106.925550582493, 48.0148627747973],
        [106.925553291251, 48.0148392395393],
        [106.925552897348, 48.0148152959892],
        [106.925549109404, 48.0147940468079],
        [106.925530072555, 48.0147524567605],
        [106.92549474089, 48.0146759361456],
        [106.925443993046, 48.0145879401813],
        [106.925412220897, 48.0145398579281],
        [106.92538088492, 48.0145035037337],
        [106.925355104954, 48.0144821430365],
        [106.925334318924, 48.0144606987024],
        [106.925326017282, 48.0144390448261],
        [106.925306605416, 48.0143874030563],
        [106.925248493024, 48.0142358277213],
        [106.925199680521, 48.0141327123549],
        [106.925127461363, 48.0140048431491],
        [106.925073405813, 48.0138951087723],
        [106.925033395875, 48.0138270480799],
        [106.925001562572, 48.013777291289],
        [106.924970290447, 48.0137426107329],
        [106.92493920538, 48.0137129573871],
        [106.924900754866, 48.013686779921],
        [106.924888529482, 48.0136724735059],
        [106.924879655872, 48.0136569593013],
        [106.924875258187, 48.0136420602329],
        [106.924873353423, 48.0136218614598],
        [106.924876974093, 48.0135849209074],
        [106.924890397374, 48.0135427858709],
        [106.924913057592, 48.0134803810148],
        [106.924925667885, 48.0134164679957],
        [106.924952448797, 48.0133305251836],
        [106.92497727638, 48.0132695340618],
        [106.925005508797, 48.0132122895156],
        [106.925030128638, 48.0131704764364],
        [106.925071554109, 48.013107246902],
        [106.925121305504, 48.0130343298705],
        [106.925145185202, 48.0130051171924],
        [106.925164438788, 48.0129849921637],
        [106.925192526414, 48.0129610243318],
        [106.925237285672, 48.0129284508873],
        [106.92528289479, 48.0128973981964],
        [106.925325111665, 48.0128716587001],
        [106.925379807532, 48.0128430080984],
        [106.925450265817, 48.0128108870129],
        [106.925551200328, 48.0127706378547],
        [106.925654881368, 48.0127370490756],
        [106.925739024636, 48.0127155220038],
        [106.925823354065, 48.0126990203436],
        [106.925927908346, 48.0126888849841],
        [106.926109549816, 48.0126690747181],
        [106.926375898429, 48.0126428145143],
        [106.926587377605, 48.0126191506533],
        [106.926741667094, 48.0126031688013],
        [106.926841302984, 48.0125947745292],
        [106.926963306811, 48.0125871392851],
        [106.927053281284, 48.0125845123654],
        [106.927132067291, 48.0125846751427],
        [106.927188296503, 48.0125872750828],
        [106.927243670459, 48.0125924974458],
        [106.92728617062, 48.0125990445103],
        [106.927344158906, 48.0126131566719],
        [106.92740233515, 48.0126322978423],
        [106.927432577551, 48.0126380597987],
        [106.927472684617, 48.0126428513865],
        [106.927523576352, 48.0126465781771],
        [106.927565251835, 48.0126463263669],
        [106.927599871237, 48.0126424044235],
        [106.927659631187, 48.0126313310711],
        [106.927741069295, 48.0126164679756],
        [106.927793522253, 48.0126039377216],
        [106.927842225938, 48.0125896079241],
        [106.92787248183, 48.0125774679758],
        [106.927898768114, 48.0125612864742],
        [106.927940582092, 48.0125277102857],
        [106.927991514297, 48.01248662206],
        [106.928015446156, 48.0124617890804],
        [106.928034644883, 48.0124372816553],
        [106.928060360997, 48.0123899134638],
        [106.928085577088, 48.0123291399779],
        [106.928101118272, 48.01227691185],
        [106.928107046603, 48.0122349045173],
        [106.928100553498, 48.0121947803649],
        [106.928091911912, 48.0121653869231],
        [106.928081013928, 48.0121397868218],
        [106.928065897223, 48.0121144070543],
        [106.928043996933, 48.0120850891556],
        [106.928013542291, 48.012052314263],
        [106.9279584804, 48.0120027058603],
        [106.927904864618, 48.0119566183034],
        [106.9278450624, 48.0119090567576],
        [106.927771152517, 48.0118543518969],
        [106.927703928194, 48.011809169058],
        [106.927654817116, 48.0117781028772],
        [106.927622159135, 48.0117602504353],
        [106.927589704401, 48.0117453540649],
        [106.927561237261, 48.0117344506844],
        [106.927532995851, 48.011725798307],
        [106.927503186023, 48.0117186621866],
        [106.927439433083, 48.0116765748141],
        [106.927346091549, 48.0116471930635],
        [106.927249116753, 48.0116154919614],
        [106.927195310315, 48.0115997304433],
        [106.927173680721, 48.0115905708482],
        [106.926999150191, 48.0115343380393],
        [106.9269589442, 48.0115007168847],
        [106.926931987022, 48.011475115884],
        [106.926907176525, 48.0114483853347],
        [106.926892788272, 48.0114288349728],
        [106.926882093534, 48.0114075417247],
        [106.926873562565, 48.0113822204132],
        [106.926868997606, 48.0113597517512],
        [106.926866758294, 48.0113337199753],
        [106.926869878942, 48.0112833759271],
        [106.92687659418, 48.011254067921],
        [106.926892037338, 48.0112075684746],
        [106.926912327842, 48.0111518428833],
        [106.926935417036, 48.011097876366],
        [106.926993775842, 48.0109879333465],
        [106.927054757071, 48.0108812980336],
        [106.927089836027, 48.0108170081984],
        [106.92710557866, 48.0107954334625],
        [106.92711848483, 48.010781323999],
        [106.927152502586, 48.0107556069857],
        [106.927203996867, 48.0107295976928],
        [106.927260359178, 48.0107001529897],
        [106.9273042389, 48.0106709187279],
        [106.927340379055, 48.0106351077241],
        [106.927407475675, 48.0105585457404],
        [106.927470772658, 48.0104803766681],
        [106.927510328439, 48.0104357082414],
        [106.927540989925, 48.010403760725],
        [106.927575630911, 48.0103780338193],
        [106.927614018472, 48.0103522448603],
        [106.927650578611, 48.0103277428311],
        [106.927673160588, 48.0103075242729],
        [106.927704740282, 48.0102727708717],
        [106.927751362935, 48.0102166684645],
        [106.927797800328, 48.0101555397464],
        [106.92783379929, 48.0101159587845],
        [106.927873869484, 48.0100851120383],
        [106.927917966841, 48.0100617413563],
        [106.927946034682, 48.010050137404],
        [106.927984486995, 48.0100367357068],
        [106.928075349997, 48.0100113217651],
        [106.928157037218, 48.009991092415],
        [106.928253892403, 48.0099756348677],
        [106.928328510952, 48.0099668376994],
        [106.928408841095, 48.0099604597075],
        [106.928515200316, 48.0099486165355],
        [106.928584357282, 48.009940502852],
        [106.928623336598, 48.0099342282821],
        [106.928666448298, 48.0099245839525],
        [106.928755113358, 48.0099005819463],
        [106.928881269355, 48.0098707388436],
        [106.928937071389, 48.0098560358274],
        [106.929050927358, 48.0098190934764],
        [106.929199637453, 48.0097623588458],
      ],
    ],
  },
};
